export default [
    {
        'path': '/andon/andon-alarm-code',
        'name': 'andon/andon-alarm-code',
        'component': () => import('@/components/content/andon/andon-alarm-code.vue')
    },
    {
        'path': '/andon/andon-alarm-notice-log',
        'name': 'andon/andon-alarm-notice-log',
        'component': () => import('@/components/content/andon/andon-alarm-notice-log.vue')
    },
    {
        'path': '/andon/andon-alarm-type',
        'name': 'andon/andon-alarm-type',
        'component': () => import('@/components/content/andon/andon-alarm-type.vue')
    },
    {
        'path': '/andon/andon-alarm',
        'name': 'andon/andon-alarm',
        'component': () => import('@/components/content/andon/andon-alarm.vue')
    },
    {
        'path': '/basic/basic-data/comp/importModel',
        'name': 'basic/basic-data/comp/importModel',
        'component': () => import('@/components/content/basic/basic-data/comp/importModel.vue')
    },
    {
        'path': '/basic/basic-data/comp/importModel2',
        'name': 'basic/basic-data/comp/importModel2',
        'component': () => import('@/components/content/basic/basic-data/comp/importModel2.vue')
    },
    {
        'path': '/basic/basic-data/comp/importModel3',
        'name': 'basic/basic-data/comp/importModel3',
        'component': () => import('@/components/content/basic/basic-data/comp/importModel3.vue')
    },
    {
        'path': '/basic/basic-data/default-config',
        'name': 'basic/basic-data/default-config',
        'component': () => import('@/components/content/basic/basic-data/default-config.vue')
    },
    {
        'path': '/basic/basic-data/dict-biz',
        'name': 'basic/basic-data/dict-biz',
        'component': () => import('@/components/content/basic/basic-data/dict-biz.vue')
    },
    {
        'path': '/basic/basic-data/dict',
        'name': 'basic/basic-data/dict',
        'component': () => import('@/components/content/basic/basic-data/dict.vue')
    },
    {
        'path': '/basic/basic-data/model',
        'name': 'basic/basic-data/model',
        'component': () => import('@/components/content/basic/basic-data/model.vue')
    },
    {
        'path': '/basic/biz-data/hi-printer-designer',
        'name': 'basic/biz-data/hi-printer-designer',
        'component': () => import('@/components/content/basic/biz-data/hi-printer-designer.vue')
    },
    {
        'path': '/basic/biz-data/material-level',
        'name': 'basic/biz-data/material-level',
        'component': () => import('@/components/content/basic/biz-data/material-level.vue')
    },
    {
        'path': '/basic/biz-data/msl',
        'name': 'basic/biz-data/msl',
        'component': () => import('@/components/content/basic/biz-data/msl.vue')
    },
    {
        'path': '/basic/biz-data/print-template',
        'name': 'basic/biz-data/print-template',
        'component': () => import('@/components/content/basic/biz-data/print-template.vue')
    },
    {
        'path': '/basic/biz-data/setTemplate',
        'name': 'basic/biz-data/setTemplate',
        'component': () => import('@/components/content/basic/biz-data/setTemplate.vue')
    },
    {
        'path': '/basic/calendar/calendar',
        'name': 'basic/calendar/calendar',
        'component': () => import('@/components/content/basic/calendar/calendar.vue')
    },
    {
        'path': '/basic/code/code-rule',
        'name': 'basic/code/code-rule',
        'component': () => import('@/components/content/basic/code/code-rule.vue')
    },
    {
        'path': '/basic/code/code-serial-num',
        'name': 'basic/code/code-serial-num',
        'component': () => import('@/components/content/basic/code/code-serial-num.vue')
    },
    {
        'path': '/basic/code/code-validate-rule-design',
        'name': 'basic/code/code-validate-rule-design',
        'component': () => import('@/components/content/basic/code/code-validate-rule-design.vue')
    },
    {
        'path': '/basic/code/code-validate-rule',
        'name': 'basic/code/code-validate-rule',
        'component': () => import('@/components/content/basic/code/code-validate-rule.vue')
    },
    {
        'path': '/basic/cron-job/basic-config-default-value',
        'name': 'basic/cron-job/basic-config-default-value',
        'component': () => import('@/components/content/basic/cron-job/basic-config-default-value.vue')
    },
    {
        'path': '/basic/cron-job/cron-job-execute-log',
        'name': 'basic/cron-job/cron-job-execute-log',
        'component': () => import('@/components/content/basic/cron-job/cron-job-execute-log.vue')
    },
    {
        'path': '/basic/master-data/customer',
        'name': 'basic/master-data/customer',
        'component': () => import('@/components/content/basic/master-data/customer.vue')
    },
    {
        'path': '/basic/master-data/file-image-upload',
        'name': 'basic/master-data/file-image-upload',
        'component': () => import('@/components/content/basic/master-data/file-image-upload.vue')
    },
    {
        'path': '/basic/master-data/material-bom',
        'name': 'basic/master-data/material-bom',
        'component': () => import('@/components/content/basic/master-data/material-bom.vue')
    },
    {
        'path': '/basic/master-data/material-class-ext-custom-field-config',
        'name': 'basic/master-data/material-class-ext-custom-field-config',
        'component': () => import('@/components/content/basic/master-data/material-class-ext-custom-field-config.vue')
    },
    {
        'path': '/basic/master-data/material-class',
        'name': 'basic/master-data/material-class',
        'component': () => import('@/components/content/basic/master-data/material-class.vue')
    },
    {
        'path': '/basic/master-data/material-ext-point',
        'name': 'basic/master-data/material-ext-point',
        'component': () => import('@/components/content/basic/master-data/material-ext-point.vue')
    },
    {
        'path': '/basic/master-data/material-ext',
        'name': 'basic/master-data/material-ext',
        'component': () => import('@/components/content/basic/master-data/material-ext.vue')
    },
    {
        'path': '/basic/master-data/material-group',
        'name': 'basic/master-data/material-group',
        'component': () => import('@/components/content/basic/master-data/material-group.vue')
    },
    {
        'path': '/basic/master-data/material-pack-rule',
        'name': 'basic/master-data/material-pack-rule',
        'component': () => import('@/components/content/basic/master-data/material-pack-rule.vue')
    },
    {
        'path': '/basic/master-data/material-sip-rel',
        'name': 'basic/master-data/material-sip-rel',
        'component': () => import('@/components/content/basic/master-data/material-sip-rel.vue')
    },
    {
        'path': '/basic/master-data/material-supply-check-code-rel',
        'name': 'basic/master-data/material-supply-check-code-rel',
        'component': () => import('@/components/content/basic/master-data/material-supply-check-code-rel.vue')
    },
    {
        'path': '/basic/master-data/material-supply-rel',
        'name': 'basic/master-data/material-supply-rel',
        'component': () => import('@/components/content/basic/master-data/material-supply-rel.vue')
    },
    {
        'path': '/basic/master-data/material',
        'name': 'basic/master-data/material',
        'component': () => import('@/components/content/basic/master-data/material.vue')
    },
    {
        'path': '/basic/master-data/supplier',
        'name': 'basic/master-data/supplier',
        'component': () => import('@/components/content/basic/master-data/supplier.vue')
    },
    {
        'path': '/basic/order-config/order-category',
        'name': 'basic/order-config/order-category',
        'component': () => import('@/components/content/basic/order-config/order-category.vue')
    },
    {
        'path': '/basic/order-config/order-type',
        'name': 'basic/order-config/order-type',
        'component': () => import('@/components/content/basic/order-config/order-type.vue')
    },
    {
        'path': '/basic/order-config/purchase-order-type',
        'name': 'basic/order-config/purchase-order-type',
        'component': () => import('@/components/content/basic/order-config/purchase-order-type.vue')
    },
    {
        'path': '/basic/page-config/basic-config-default-value',
        'name': 'basic/page-config/basic-config-default-value',
        'component': () => import('@/components/content/basic/page-config/basic-config-default-value.vue')
    },
    {
        'path': '/basic/page-config/basic-page-field-config',
        'name': 'basic/page-config/basic-page-field-config',
        'component': () => import('@/components/content/basic/page-config/basic-page-field-config.vue')
    },
    {
        'path': '/basic/public-information/unit-covert',
        'name': 'basic/public-information/unit-covert',
        'component': () => import('@/components/content/basic/public-information/unit-covert.vue')
    },
    {
        'path': '/basic/public-information/unit-group',
        'name': 'basic/public-information/unit-group',
        'component': () => import('@/components/content/basic/public-information/unit-group.vue')
    },
    {
        'path': '/basic/public-information/unit',
        'name': 'basic/public-information/unit',
        'component': () => import('@/components/content/basic/public-information/unit.vue')
    },
    {
        'path': '/basic/quality/basic-defect-category-config',
        'name': 'basic/quality/basic-defect-category-config',
        'component': () => import('@/components/content/basic/quality/basic-defect-category-config.vue')
    },
    {
        'path': '/basic/quality/basic-defect-config',
        'name': 'basic/quality/basic-defect-config',
        'component': () => import('@/components/content/basic/quality/basic-defect-config.vue')
    },
    {
        'path': '/basic/quality/basic-reason-category-config',
        'name': 'basic/quality/basic-reason-category-config',
        'component': () => import('@/components/content/basic/quality/basic-reason-category-config.vue')
    },
    {
        'path': '/basic/quality/basic-reason-config',
        'name': 'basic/quality/basic-reason-config',
        'component': () => import('@/components/content/basic/quality/basic-reason-config.vue')
    },
    {
        'path': '/basic/quality/basic-repair-category-config',
        'name': 'basic/quality/basic-repair-category-config',
        'component': () => import('@/components/content/basic/quality/basic-repair-category-config.vue')
    },
    {
        'path': '/basic/quality/basic-repair-config',
        'name': 'basic/quality/basic-repair-config',
        'component': () => import('@/components/content/basic/quality/basic-repair-config.vue')
    },
    {
        'path': '/basic/quality/basic-test-category-config',
        'name': 'basic/quality/basic-test-category-config',
        'component': () => import('@/components/content/basic/quality/basic-test-category-config.vue')
    },
    {
        'path': '/basic/quality/basic-test-config',
        'name': 'basic/quality/basic-test-config',
        'component': () => import('@/components/content/basic/quality/basic-test-config.vue')
    },
    {
        'path': '/basic/stock-manager/warehouse-area',
        'name': 'basic/stock-manager/warehouse-area',
        'component': () => import('@/components/content/basic/stock-manager/warehouse-area.vue')
    },
    {
        'path': '/basic/stock-manager/warehouse-location',
        'name': 'basic/stock-manager/warehouse-location',
        'component': () => import('@/components/content/basic/stock-manager/warehouse-location.vue')
    },
    {
        'path': '/basic/stock-manager/warehouse-material-rel',
        'name': 'basic/stock-manager/warehouse-material-rel',
        'component': () => import('@/components/content/basic/stock-manager/warehouse-material-rel.vue')
    },
    {
        'path': '/basic/stock-manager/warehouse',
        'name': 'basic/stock-manager/warehouse',
        'component': () => import('@/components/content/basic/stock-manager/warehouse.vue')
    },
    {
        'path': '/boards/board-frame',
        'name': 'boards/board-frame',
        'component': () => import('@/components/content/boards/board-frame.vue')
    },
    {
        'path': '/boards/board-sample',
        'name': 'boards/board-sample',
        'component': () => import('@/components/content/boards/board-sample.vue')
    },
    {
        'path': '/common/block',
        'name': 'common/block',
        'component': () => import('@/components/content/common/block.vue')
    },
    {
        'path': '/common/hi-printer/etao-hi-printer',
        'name': 'common/hi-printer/etao-hi-printer',
        'component': () => import('@/components/content/common/hi-printer/etao-hi-printer.vue')
    },
    {
        'path': '/common/preview/file-preview',
        'name': 'common/preview/file-preview',
        'component': () => import('@/components/content/common/preview/file-preview.vue')
    },
    {
        'path': '/common/preview/file-show',
        'name': 'common/preview/file-show',
        'component': () => import('@/components/content/common/preview/file-show.vue')
    },
    {
        'path': '/common/print/logoSvg',
        'name': 'common/print/logoSvg',
        'component': () => import('@/components/content/common/print/logoSvg.vue')
    },
    {
        'path': '/common/print/printer',
        'name': 'common/print/printer',
        'component': () => import('@/components/content/common/print/printer.vue')
    },
    {
        'path': '/common/print/printLabel',
        'name': 'common/print/printLabel',
        'component': () => import('@/components/content/common/print/printLabel.vue')
    },
    {
        'path': '/common/printTemplate/comp/drawBoard',
        'name': 'common/printTemplate/comp/drawBoard',
        'component': () => import('@/components/content/common/printTemplate/comp/drawBoard.vue')
    },
    {
        'path': '/common/printTemplate/comp/elemForm',
        'name': 'common/printTemplate/comp/elemForm',
        'component': () => import('@/components/content/common/printTemplate/comp/elemForm.vue')
    },
    {
        'path': '/common/printTemplate/comp/paperForm',
        'name': 'common/printTemplate/comp/paperForm',
        'component': () => import('@/components/content/common/printTemplate/comp/paperForm.vue')
    },
    {
        'path': '/common/printTemplate/comp/templateElement',
        'name': 'common/printTemplate/comp/templateElement',
        'component': () => import('@/components/content/common/printTemplate/comp/templateElement.vue')
    },
    {
        'path': '/common/printTemplate/comp/templatePaper',
        'name': 'common/printTemplate/comp/templatePaper',
        'component': () => import('@/components/content/common/printTemplate/comp/templatePaper.vue')
    },
    {
        'path': '/common/printTemplate/packPrinter',
        'name': 'common/printTemplate/packPrinter',
        'component': () => import('@/components/content/common/printTemplate/packPrinter.vue')
    },
    {
        'path': '/common/printTemplate/template-design-test',
        'name': 'common/printTemplate/template-design-test',
        'component': () => import('@/components/content/common/printTemplate/template-design-test.vue')
    },
    {
        'path': '/common/printTemplate/templateDesign',
        'name': 'common/printTemplate/templateDesign',
        'component': () => import('@/components/content/common/printTemplate/templateDesign.vue')
    },
    {
        'path': '/common/printTemplate/webLabelDesign',
        'name': 'common/printTemplate/webLabelDesign',
        'component': () => import('@/components/content/common/printTemplate/webLabelDesign.vue')
    },
    {
        'path': '/common/printTemplate/webLabelDesigner',
        'name': 'common/printTemplate/webLabelDesigner',
        'component': () => import('@/components/content/common/printTemplate/webLabelDesigner.vue')
    },
    {
        'path': '/develop/code',
        'name': 'develop/code',
        'component': () => import('@/components/content/develop/code.vue')
    },
    {
        'path': '/develop/datasource',
        'name': 'develop/datasource',
        'component': () => import('@/components/content/develop/datasource.vue')
    },
    {
        'path': '/develop/model-config',
        'name': 'develop/model-config',
        'component': () => import('@/components/content/develop/model-config.vue')
    },
    {
        'path': '/develop/model',
        'name': 'develop/model',
        'component': () => import('@/components/content/develop/model.vue')
    },
    {
        'path': '/flow/category/index',
        'name': 'flow/category/index',
        'component': () => import('@/components/content/flow/category/index.vue')
    },
    {
        'path': '/flow/definition/index',
        'name': 'flow/definition/index',
        'component': () => import('@/components/content/flow/definition/index.vue')
    },
    {
        'path': '/flow/definition/model',
        'name': 'flow/definition/model',
        'component': () => import('@/components/content/flow/definition/model.vue')
    },
    {
        'path': '/flow/Editor/index',
        'name': 'flow/Editor/index',
        'component': () => import('@/components/content/flow/Editor/index.vue')
    },
    {
        'path': '/flow/expression/index',
        'name': 'flow/expression/index',
        'component': () => import('@/components/content/flow/expression/index.vue')
    },
    {
        'path': '/flow/form',
        'name': 'flow/form',
        'component': () => import('@/components/content/flow/form.vue')
    },
    {
        'path': '/flow/iFrame/index',
        'name': 'flow/iFrame/index',
        'component': () => import('@/components/content/flow/iFrame/index.vue')
    },
    {
        'path': '/flow/listener/index',
        'name': 'flow/listener/index',
        'component': () => import('@/components/content/flow/listener/index.vue')
    },
    {
        'path': '/flow/parser/example/Index',
        'name': 'flow/parser/example/Index',
        'component': () => import('@/components/content/flow/parser/example/Index.vue')
    },
    {
        'path': '/flow/parser/Parser',
        'name': 'flow/parser/Parser',
        'component': () => import('@/components/content/flow/parser/Parser.vue')
    },
    {
        'path': '/flow/Process/components/custom/customContextPad',
        'name': 'flow/Process/components/custom/customContextPad',
        'component': () => import('@/components/content/flow/Process/components/custom/customContextPad.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/gateway',
        'name': 'flow/Process/components/nodePanel/gateway',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/gateway.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/process',
        'name': 'flow/Process/components/nodePanel/process',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/process.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/classListenerParam',
        'name': 'flow/Process/components/nodePanel/property/classListenerParam',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/classListenerParam.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/executionListener',
        'name': 'flow/Process/components/nodePanel/property/executionListener',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/executionListener.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/listenerList',
        'name': 'flow/Process/components/nodePanel/property/listenerList',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/listenerList.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/listenerParam',
        'name': 'flow/Process/components/nodePanel/property/listenerParam',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/listenerParam.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/multiInstance',
        'name': 'flow/Process/components/nodePanel/property/multiInstance',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/multiInstance.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/signal',
        'name': 'flow/Process/components/nodePanel/property/signal',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/signal.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/property/taskListener',
        'name': 'flow/Process/components/nodePanel/property/taskListener',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/property/taskListener.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/sequenceFlow',
        'name': 'flow/Process/components/nodePanel/sequenceFlow',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/sequenceFlow.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/startEnd',
        'name': 'flow/Process/components/nodePanel/startEnd',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/startEnd.vue')
    },
    {
        'path': '/flow/Process/components/nodePanel/task',
        'name': 'flow/Process/components/nodePanel/task',
        'component': () => import('@/components/content/flow/Process/components/nodePanel/task.vue')
    },
    {
        'path': '/flow/Process/index',
        'name': 'flow/Process/index',
        'component': () => import('@/components/content/flow/Process/index.vue')
    },
    {
        'path': '/flow/Process/PropertyPanel',
        'name': 'flow/Process/PropertyPanel',
        'component': () => import('@/components/content/flow/Process/PropertyPanel.vue')
    },
    {
        'path': '/flow/role/index',
        'name': 'flow/role/index',
        'component': () => import('@/components/content/flow/role/index.vue')
    },
    {
        'path': '/flow/task/assembly/flowRecord',
        'name': 'flow/task/assembly/flowRecord',
        'component': () => import('@/components/content/flow/task/assembly/flowRecord.vue')
    },
    {
        'path': '/flow/task/basic/index',
        'name': 'flow/task/basic/index',
        'component': () => import('@/components/content/flow/task/basic/index.vue')
    },
    {
        'path': '/flow/task/finished/detail/flow',
        'name': 'flow/task/finished/detail/flow',
        'component': () => import('@/components/content/flow/task/finished/detail/flow.vue')
    },
    {
        'path': '/flow/task/finished/detail/flowview',
        'name': 'flow/task/finished/detail/flowview',
        'component': () => import('@/components/content/flow/task/finished/detail/flowview.vue')
    },
    {
        'path': '/flow/task/finished/detail/index',
        'name': 'flow/task/finished/detail/index',
        'component': () => import('@/components/content/flow/task/finished/detail/index.vue')
    },
    {
        'path': '/flow/task/finished/index',
        'name': 'flow/task/finished/index',
        'component': () => import('@/components/content/flow/task/finished/index.vue')
    },
    {
        'path': '/flow/task/form/index',
        'name': 'flow/task/form/index',
        'component': () => import('@/components/content/flow/task/form/index.vue')
    },
    {
        'path': '/flow/task/myProcess/detail/flow',
        'name': 'flow/task/myProcess/detail/flow',
        'component': () => import('@/components/content/flow/task/myProcess/detail/flow.vue')
    },
    {
        'path': '/flow/task/myProcess/detail/flowview',
        'name': 'flow/task/myProcess/detail/flowview',
        'component': () => import('@/components/content/flow/task/myProcess/detail/flowview.vue')
    },
    {
        'path': '/flow/task/myProcess/detail/index',
        'name': 'flow/task/myProcess/detail/index',
        'component': () => import('@/components/content/flow/task/myProcess/detail/index.vue')
    },
    {
        'path': '/flow/task/myProcess/index',
        'name': 'flow/task/myProcess/index',
        'component': () => import('@/components/content/flow/task/myProcess/index.vue')
    },
    {
        'path': '/flow/task/myProcess/send/flow',
        'name': 'flow/task/myProcess/send/flow',
        'component': () => import('@/components/content/flow/task/myProcess/send/flow.vue')
    },
    {
        'path': '/flow/task/myProcess/send/flowview',
        'name': 'flow/task/myProcess/send/flowview',
        'component': () => import('@/components/content/flow/task/myProcess/send/flowview.vue')
    },
    {
        'path': '/flow/task/myProcess/send/index',
        'name': 'flow/task/myProcess/send/index',
        'component': () => import('@/components/content/flow/task/myProcess/send/index.vue')
    },
    {
        'path': '/flow/task/record/flow',
        'name': 'flow/task/record/flow',
        'component': () => import('@/components/content/flow/task/record/flow.vue')
    },
    {
        'path': '/flow/task/record/flowview',
        'name': 'flow/task/record/flowview',
        'component': () => import('@/components/content/flow/task/record/flowview.vue')
    },
    {
        'path': '/flow/task/record/index',
        'name': 'flow/task/record/index',
        'component': () => import('@/components/content/flow/task/record/index.vue')
    },
    {
        'path': '/flow/task/todo/detail/flow',
        'name': 'flow/task/todo/detail/flow',
        'component': () => import('@/components/content/flow/task/todo/detail/flow.vue')
    },
    {
        'path': '/flow/task/todo/detail/flowview',
        'name': 'flow/task/todo/detail/flowview',
        'component': () => import('@/components/content/flow/task/todo/detail/flowview.vue')
    },
    {
        'path': '/flow/task/todo/detail/index',
        'name': 'flow/task/todo/detail/index',
        'component': () => import('@/components/content/flow/task/todo/detail/index.vue')
    },
    {
        'path': '/flow/task/todo/index',
        'name': 'flow/task/todo/index',
        'component': () => import('@/components/content/flow/task/todo/index.vue')
    },
    {
        'path': '/flow/tinymce/index',
        'name': 'flow/tinymce/index',
        'component': () => import('@/components/content/flow/tinymce/index.vue')
    },
    {
        'path': '/flow/tool/build/App',
        'name': 'flow/tool/build/App',
        'component': () => import('@/components/content/flow/tool/build/App.vue')
    },
    {
        'path': '/flow/tool/build/CodeTypeDialog',
        'name': 'flow/tool/build/CodeTypeDialog',
        'component': () => import('@/components/content/flow/tool/build/CodeTypeDialog.vue')
    },
    {
        'path': '/flow/tool/build/DraggableItem',
        'name': 'flow/tool/build/DraggableItem',
        'component': () => import('@/components/content/flow/tool/build/DraggableItem.vue')
    },
    {
        'path': '/flow/tool/build/FormDrawer',
        'name': 'flow/tool/build/FormDrawer',
        'component': () => import('@/components/content/flow/tool/build/FormDrawer.vue')
    },
    {
        'path': '/flow/tool/build/IconsDialog',
        'name': 'flow/tool/build/IconsDialog',
        'component': () => import('@/components/content/flow/tool/build/IconsDialog.vue')
    },
    {
        'path': '/flow/tool/build/index',
        'name': 'flow/tool/build/index',
        'component': () => import('@/components/content/flow/tool/build/index.vue')
    },
    {
        'path': '/flow/tool/build/JsonDrawer',
        'name': 'flow/tool/build/JsonDrawer',
        'component': () => import('@/components/content/flow/tool/build/JsonDrawer.vue')
    },
    {
        'path': '/flow/tool/build/ResourceDialog',
        'name': 'flow/tool/build/ResourceDialog',
        'component': () => import('@/components/content/flow/tool/build/ResourceDialog.vue')
    },
    {
        'path': '/flow/tool/build/RightPanel',
        'name': 'flow/tool/build/RightPanel',
        'component': () => import('@/components/content/flow/tool/build/RightPanel.vue')
    },
    {
        'path': '/flow/tool/build/TreeNodeDialog',
        'name': 'flow/tool/build/TreeNodeDialog',
        'component': () => import('@/components/content/flow/tool/build/TreeNodeDialog.vue')
    },
    {
        'path': '/flow/user/index',
        'name': 'flow/user/index',
        'component': () => import('@/components/content/flow/user/index.vue')
    },
    {
        'path': '/iot/accessory/accessory-ledger',
        'name': 'iot/accessory/accessory-ledger',
        'component': () => import('@/components/content/iot/accessory/accessory-ledger.vue')
    },
    {
        'path': '/iot/accessory/accessory-operation',
        'name': 'iot/accessory/accessory-operation',
        'component': () => import('@/components/content/iot/accessory/accessory-operation.vue')
    },
    {
        'path': '/iot/accessory/device-inventory-action',
        'name': 'iot/accessory/device-inventory-action',
        'component': () => import('@/components/content/iot/accessory/device-inventory-action.vue')
    },
    {
        'path': '/iot/accessory/iot-accessory-category',
        'name': 'iot/accessory/iot-accessory-category',
        'component': () => import('@/components/content/iot/accessory/iot-accessory-category.vue')
    },
    {
        'path': '/iot/accessory/iot-accessory-model',
        'name': 'iot/accessory/iot-accessory-model',
        'component': () => import('@/components/content/iot/accessory/iot-accessory-model.vue')
    },
    {
        'path': '/iot/calibration/iot-calibration-plan',
        'name': 'iot/calibration/iot-calibration-plan',
        'component': () => import('@/components/content/iot/calibration/iot-calibration-plan.vue')
    },
    {
        'path': '/iot/calibration/iot-calibration-stand',
        'name': 'iot/calibration/iot-calibration-stand',
        'component': () => import('@/components/content/iot/calibration/iot-calibration-stand.vue')
    },
    {
        'path': '/iot/calibration/iot-calibration-task',
        'name': 'iot/calibration/iot-calibration-task',
        'component': () => import('@/components/content/iot/calibration/iot-calibration-task.vue')
    },
    {
        'path': '/iot/calibration/report/iot-calibration-bottom-report',
        'name': 'iot/calibration/report/iot-calibration-bottom-report',
        'component': () => import('@/components/content/iot/calibration/report/iot-calibration-bottom-report.vue')
    },
    {
        'path': '/iot/calibration/report/iot-calibration-header-report',
        'name': 'iot/calibration/report/iot-calibration-header-report',
        'component': () => import('@/components/content/iot/calibration/report/iot-calibration-header-report.vue')
    },
    {
        'path': '/iot/calibration/report/iot-calibration-item-report',
        'name': 'iot/calibration/report/iot-calibration-item-report',
        'component': () => import('@/components/content/iot/calibration/report/iot-calibration-item-report.vue')
    },
    {
        'path': '/iot/calibration/report/iot-calibration-report',
        'name': 'iot/calibration/report/iot-calibration-report',
        'component': () => import('@/components/content/iot/calibration/report/iot-calibration-report.vue')
    },
    {
        'path': '/iot/collect/iot-ibox-control',
        'name': 'iot/collect/iot-ibox-control',
        'component': () => import('@/components/content/iot/collect/iot-ibox-control.vue')
    },
    {
        'path': '/iot/collect/iot-smt-collect-log',
        'name': 'iot/collect/iot-smt-collect-log',
        'component': () => import('@/components/content/iot/collect/iot-smt-collect-log.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-aoi-report-item',
        'name': 'iot/equipmentReport/iot-aoi-report-item',
        'component': () => import('@/components/content/iot/equipmentReport/iot-aoi-report-item.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-aoi-report',
        'name': 'iot/equipmentReport/iot-aoi-report',
        'component': () => import('@/components/content/iot/equipmentReport/iot-aoi-report.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-mac-burn-report',
        'name': 'iot/equipmentReport/iot-mac-burn-report',
        'component': () => import('@/components/content/iot/equipmentReport/iot-mac-burn-report.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-printer-report-item',
        'name': 'iot/equipmentReport/iot-printer-report-item',
        'component': () => import('@/components/content/iot/equipmentReport/iot-printer-report-item.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-printer-report',
        'name': 'iot/equipmentReport/iot-printer-report',
        'component': () => import('@/components/content/iot/equipmentReport/iot-printer-report.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-reflow-report-item',
        'name': 'iot/equipmentReport/iot-reflow-report-item',
        'component': () => import('@/components/content/iot/equipmentReport/iot-reflow-report-item.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-reflow-report',
        'name': 'iot/equipmentReport/iot-reflow-report',
        'component': () => import('@/components/content/iot/equipmentReport/iot-reflow-report.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-spi-report-item',
        'name': 'iot/equipmentReport/iot-spi-report-item',
        'component': () => import('@/components/content/iot/equipmentReport/iot-spi-report-item.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-spi-report',
        'name': 'iot/equipmentReport/iot-spi-report',
        'component': () => import('@/components/content/iot/equipmentReport/iot-spi-report.vue')
    },
    {
        'path': '/iot/equipmentReport/iot-tool-inspection-report',
        'name': 'iot/equipmentReport/iot-tool-inspection-report',
        'component': () => import('@/components/content/iot/equipmentReport/iot-tool-inspection-report.vue')
    },
    {
        'path': '/iot/feeder/feeder-brand-type',
        'name': 'iot/feeder/feeder-brand-type',
        'component': () => import('@/components/content/iot/feeder/feeder-brand-type.vue')
    },
    {
        'path': '/iot/feeder/feeder-expired',
        'name': 'iot/feeder/feeder-expired',
        'component': () => import('@/components/content/iot/feeder/feeder-expired.vue')
    },
    {
        'path': '/iot/feeder/feeder-in-house',
        'name': 'iot/feeder/feeder-in-house',
        'component': () => import('@/components/content/iot/feeder/feeder-in-house.vue')
    },
    {
        'path': '/iot/feeder/feeder-maintain-log',
        'name': 'iot/feeder/feeder-maintain-log',
        'component': () => import('@/components/content/iot/feeder/feeder-maintain-log.vue')
    },
    {
        'path': '/iot/feeder/feeder-maintain-station-config',
        'name': 'iot/feeder/feeder-maintain-station-config',
        'component': () => import('@/components/content/iot/feeder/feeder-maintain-station-config.vue')
    },
    {
        'path': '/iot/feeder/feeder-maintain',
        'name': 'iot/feeder/feeder-maintain',
        'component': () => import('@/components/content/iot/feeder/feeder-maintain.vue')
    },
    {
        'path': '/iot/feeder/feeder-repair',
        'name': 'iot/feeder/feeder-repair',
        'component': () => import('@/components/content/iot/feeder/feeder-repair.vue')
    },
    {
        'path': '/iot/inspection/iot-inspection-plan',
        'name': 'iot/inspection/iot-inspection-plan',
        'component': () => import('@/components/content/iot/inspection/iot-inspection-plan.vue')
    },
    {
        'path': '/iot/inspection/iot-inspection-stand',
        'name': 'iot/inspection/iot-inspection-stand',
        'component': () => import('@/components/content/iot/inspection/iot-inspection-stand.vue')
    },
    {
        'path': '/iot/inspection/iot-inspection-task',
        'name': 'iot/inspection/iot-inspection-task',
        'component': () => import('@/components/content/iot/inspection/iot-inspection-task.vue')
    },
    {
        'path': '/iot/inspection/report/iot-inspection-bottom-report',
        'name': 'iot/inspection/report/iot-inspection-bottom-report',
        'component': () => import('@/components/content/iot/inspection/report/iot-inspection-bottom-report.vue')
    },
    {
        'path': '/iot/inspection/report/iot-inspection-header-report',
        'name': 'iot/inspection/report/iot-inspection-header-report',
        'component': () => import('@/components/content/iot/inspection/report/iot-inspection-header-report.vue')
    },
    {
        'path': '/iot/inspection/report/iot-inspection-item-report',
        'name': 'iot/inspection/report/iot-inspection-item-report',
        'component': () => import('@/components/content/iot/inspection/report/iot-inspection-item-report.vue')
    },
    {
        'path': '/iot/inspection/report/iot-inspection-report',
        'name': 'iot/inspection/report/iot-inspection-report',
        'component': () => import('@/components/content/iot/inspection/report/iot-inspection-report.vue')
    },
    {
        'path': '/iot/iot-center/iot-basic-property',
        'name': 'iot/iot-center/iot-basic-property',
        'component': () => import('@/components/content/iot/iot-center/iot-basic-property.vue')
    },
    {
        'path': '/iot/iot-center/iot-channel-config',
        'name': 'iot/iot-center/iot-channel-config',
        'component': () => import('@/components/content/iot/iot-center/iot-channel-config.vue')
    },
    {
        'path': '/iot/iot-center/iot-data-calculation-rule-codemirror',
        'name': 'iot/iot-center/iot-data-calculation-rule-codemirror',
        'component': () => import('@/components/content/iot/iot-center/iot-data-calculation-rule-codemirror.vue')
    },
    {
        'path': '/iot/iot-center/iot-data-calculation-rule',
        'name': 'iot/iot-center/iot-data-calculation-rule',
        'component': () => import('@/components/content/iot/iot-center/iot-data-calculation-rule.vue')
    },
    {
        'path': '/iot/iot-center/iot-data-collect-file-log',
        'name': 'iot/iot-center/iot-data-collect-file-log',
        'component': () => import('@/components/content/iot/iot-center/iot-data-collect-file-log.vue')
    },
    {
        'path': '/iot/iot-center/iot-data-collect-log',
        'name': 'iot/iot-center/iot-data-collect-log',
        'component': () => import('@/components/content/iot/iot-center/iot-data-collect-log.vue')
    },
    {
        'path': '/iot/iot-center/iot-data-transmission-log',
        'name': 'iot/iot-center/iot-data-transmission-log',
        'component': () => import('@/components/content/iot/iot-center/iot-data-transmission-log.vue')
    },
    {
        'path': '/iot/iot-center/iot-edge-gateway',
        'name': 'iot/iot-center/iot-edge-gateway',
        'component': () => import('@/components/content/iot/iot-center/iot-edge-gateway.vue')
    },
    {
        'path': '/iot/iot-center/iot-equipment-access',
        'name': 'iot/iot-center/iot-equipment-access',
        'component': () => import('@/components/content/iot/iot-center/iot-equipment-access.vue')
    },
    {
        'path': '/iot/iot-center/iot-equipment-data-array-simulation',
        'name': 'iot/iot-center/iot-equipment-data-array-simulation',
        'component': () => import('@/components/content/iot/iot-center/iot-equipment-data-array-simulation.vue')
    },
    {
        'path': '/iot/iot-center/iot-equipment-data-simulation',
        'name': 'iot/iot-center/iot-equipment-data-simulation',
        'component': () => import('@/components/content/iot/iot-center/iot-equipment-data-simulation.vue')
    },
    {
        'path': '/iot/iot-center/iot-equipment-data-trend',
        'name': 'iot/iot-center/iot-equipment-data-trend',
        'component': () => import('@/components/content/iot/iot-center/iot-equipment-data-trend.vue')
    },
    {
        'path': '/iot/iot-center/iot-equipment-monitoring',
        'name': 'iot/iot-center/iot-equipment-monitoring',
        'component': () => import('@/components/content/iot/iot-center/iot-equipment-monitoring.vue')
    },
    {
        'path': '/iot/iot-center/iot-thing-model-property',
        'name': 'iot/iot-center/iot-thing-model-property',
        'component': () => import('@/components/content/iot/iot-center/iot-thing-model-property.vue')
    },
    {
        'path': '/iot/iot-center/iot-thing-model',
        'name': 'iot/iot-center/iot-thing-model',
        'component': () => import('@/components/content/iot/iot-center/iot-thing-model.vue')
    },
    {
        'path': '/iot/iot-center/iot-transmission-rule',
        'name': 'iot/iot-center/iot-transmission-rule',
        'component': () => import('@/components/content/iot/iot-center/iot-transmission-rule.vue')
    },
    {
        'path': '/iot/iot-center/iot-variable-template',
        'name': 'iot/iot-center/iot-variable-template',
        'component': () => import('@/components/content/iot/iot-center/iot-variable-template.vue')
    },
    {
        'path': '/iot/maintain/iot-maintain-plan',
        'name': 'iot/maintain/iot-maintain-plan',
        'component': () => import('@/components/content/iot/maintain/iot-maintain-plan.vue')
    },
    {
        'path': '/iot/maintain/iot-maintain-stand',
        'name': 'iot/maintain/iot-maintain-stand',
        'component': () => import('@/components/content/iot/maintain/iot-maintain-stand.vue')
    },
    {
        'path': '/iot/maintain/iot-maintain-task',
        'name': 'iot/maintain/iot-maintain-task',
        'component': () => import('@/components/content/iot/maintain/iot-maintain-task.vue')
    },
    {
        'path': '/iot/maintain/report/iot-maintain-bottom-report',
        'name': 'iot/maintain/report/iot-maintain-bottom-report',
        'component': () => import('@/components/content/iot/maintain/report/iot-maintain-bottom-report.vue')
    },
    {
        'path': '/iot/maintain/report/iot-maintain-header-report',
        'name': 'iot/maintain/report/iot-maintain-header-report',
        'component': () => import('@/components/content/iot/maintain/report/iot-maintain-header-report.vue')
    },
    {
        'path': '/iot/maintain/report/iot-maintain-item-report',
        'name': 'iot/maintain/report/iot-maintain-item-report',
        'component': () => import('@/components/content/iot/maintain/report/iot-maintain-item-report.vue')
    },
    {
        'path': '/iot/maintain/report/iot-maintain-report',
        'name': 'iot/maintain/report/iot-maintain-report',
        'component': () => import('@/components/content/iot/maintain/report/iot-maintain-report.vue')
    },
    {
        'path': '/iot/model/iot-equipment-category',
        'name': 'iot/model/iot-equipment-category',
        'component': () => import('@/components/content/iot/model/iot-equipment-category.vue')
    },
    {
        'path': '/iot/model/iot-equipment-ext-config',
        'name': 'iot/model/iot-equipment-ext-config',
        'component': () => import('@/components/content/iot/model/iot-equipment-ext-config.vue')
    },
    {
        'path': '/iot/model/iot-equipment-model',
        'name': 'iot/model/iot-equipment-model',
        'component': () => import('@/components/content/iot/model/iot-equipment-model.vue')
    },
    {
        'path': '/iot/model/iot-equipment-operate-log',
        'name': 'iot/model/iot-equipment-operate-log',
        'component': () => import('@/components/content/iot/model/iot-equipment-operate-log.vue')
    },
    {
        'path': '/iot/model/iot-equipment-print',
        'name': 'iot/model/iot-equipment-print',
        'component': () => import('@/components/content/iot/model/iot-equipment-print.vue')
    },
    {
        'path': '/iot/model/iot-equipment-verification-form',
        'name': 'iot/model/iot-equipment-verification-form',
        'component': () => import('@/components/content/iot/model/iot-equipment-verification-form.vue')
    },
    {
        'path': '/iot/model/iot-equipment-verification',
        'name': 'iot/model/iot-equipment-verification',
        'component': () => import('@/components/content/iot/model/iot-equipment-verification.vue')
    },
    {
        'path': '/iot/model/iot-equipment',
        'name': 'iot/model/iot-equipment',
        'component': () => import('@/components/content/iot/model/iot-equipment.vue')
    },
    {
        'path': '/iot/model/iot-location',
        'name': 'iot/model/iot-location',
        'component': () => import('@/components/content/iot/model/iot-location.vue')
    },
    {
        'path': '/iot/repair/iot-equipment-entry-defect',
        'name': 'iot/repair/iot-equipment-entry-defect',
        'component': () => import('@/components/content/iot/repair/iot-equipment-entry-defect.vue')
    },
    {
        'path': '/iot/repair/iot-equipment-repair-exec',
        'name': 'iot/repair/iot-equipment-repair-exec',
        'component': () => import('@/components/content/iot/repair/iot-equipment-repair-exec.vue')
    },
    {
        'path': '/iot/repair/iot-equipment-repair-report',
        'name': 'iot/repair/iot-equipment-repair-report',
        'component': () => import('@/components/content/iot/repair/iot-equipment-repair-report.vue')
    },
    {
        'path': '/iot/repair/iot-equipment-repair',
        'name': 'iot/repair/iot-equipment-repair',
        'component': () => import('@/components/content/iot/repair/iot-equipment-repair.vue')
    },
    {
        'path': '/mes/acc/mes-acc-category',
        'name': 'mes/acc/mes-acc-category',
        'component': () => import('@/components/content/mes/acc/mes-acc-category.vue')
    },
    {
        'path': '/mes/acc/mes-acc-check',
        'name': 'mes/acc/mes-acc-check',
        'component': () => import('@/components/content/mes/acc/mes-acc-check.vue')
    },
    {
        'path': '/mes/acc/mes-acc-empties-recycling',
        'name': 'mes/acc/mes-acc-empties-recycling',
        'component': () => import('@/components/content/mes/acc/mes-acc-empties-recycling.vue')
    },
    {
        'path': '/mes/acc/mes-acc-in',
        'name': 'mes/acc/mes-acc-in',
        'component': () => import('@/components/content/mes/acc/mes-acc-in.vue')
    },
    {
        'path': '/mes/acc/mes-acc-model-temp',
        'name': 'mes/acc/mes-acc-model-temp',
        'component': () => import('@/components/content/mes/acc/mes-acc-model-temp.vue')
    },
    {
        'path': '/mes/acc/mes-acc-model',
        'name': 'mes/acc/mes-acc-model',
        'component': () => import('@/components/content/mes/acc/mes-acc-model.vue')
    },
    {
        'path': '/mes/acc/mes-acc-open',
        'name': 'mes/acc/mes-acc-open',
        'component': () => import('@/components/content/mes/acc/mes-acc-open.vue')
    },
    {
        'path': '/mes/acc/mes-acc-operate-log',
        'name': 'mes/acc/mes-acc-operate-log',
        'component': () => import('@/components/content/mes/acc/mes-acc-operate-log.vue')
    },
    {
        'path': '/mes/acc/mes-acc-out',
        'name': 'mes/acc/mes-acc-out',
        'component': () => import('@/components/content/mes/acc/mes-acc-out.vue')
    },
    {
        'path': '/mes/acc/mes-acc-recycling',
        'name': 'mes/acc/mes-acc-recycling',
        'component': () => import('@/components/content/mes/acc/mes-acc-recycling.vue')
    },
    {
        'path': '/mes/acc/mes-acc-register',
        'name': 'mes/acc/mes-acc-register',
        'component': () => import('@/components/content/mes/acc/mes-acc-register.vue')
    },
    {
        'path': '/mes/acc/mes-acc-return',
        'name': 'mes/acc/mes-acc-return',
        'component': () => import('@/components/content/mes/acc/mes-acc-return.vue')
    },
    {
        'path': '/mes/acc/mes-acc-rewarming-end',
        'name': 'mes/acc/mes-acc-rewarming-end',
        'component': () => import('@/components/content/mes/acc/mes-acc-rewarming-end.vue')
    },
    {
        'path': '/mes/acc/mes-acc-rewarming-start',
        'name': 'mes/acc/mes-acc-rewarming-start',
        'component': () => import('@/components/content/mes/acc/mes-acc-rewarming-start.vue')
    },
    {
        'path': '/mes/acc/mes-acc-rewarming',
        'name': 'mes/acc/mes-acc-rewarming',
        'component': () => import('@/components/content/mes/acc/mes-acc-rewarming.vue')
    },
    {
        'path': '/mes/acc/mes-acc-scrap',
        'name': 'mes/acc/mes-acc-scrap',
        'component': () => import('@/components/content/mes/acc/mes-acc-scrap.vue')
    },
    {
        'path': '/mes/acc/mes-acc-sn',
        'name': 'mes/acc/mes-acc-sn',
        'component': () => import('@/components/content/mes/acc/mes-acc-sn.vue')
    },
    {
        'path': '/mes/acc/mes-acc-stir-end',
        'name': 'mes/acc/mes-acc-stir-end',
        'component': () => import('@/components/content/mes/acc/mes-acc-stir-end.vue')
    },
    {
        'path': '/mes/acc/mes-acc-stir-start',
        'name': 'mes/acc/mes-acc-stir-start',
        'component': () => import('@/components/content/mes/acc/mes-acc-stir-start.vue')
    },
    {
        'path': '/mes/acc/mes-acc-stir',
        'name': 'mes/acc/mes-acc-stir',
        'component': () => import('@/components/content/mes/acc/mes-acc-stir.vue')
    },
    {
        'path': '/mes/acc/mes-acc-stock',
        'name': 'mes/acc/mes-acc-stock',
        'component': () => import('@/components/content/mes/acc/mes-acc-stock.vue')
    },
    {
        'path': '/mes/apply/mes-material-apply-list',
        'name': 'mes/apply/mes-material-apply-list',
        'component': () => import('@/components/content/mes/apply/mes-material-apply-list.vue')
    },
    {
        'path': '/mes/apply/mes-material-apply-order-add',
        'name': 'mes/apply/mes-material-apply-order-add',
        'component': () => import('@/components/content/mes/apply/mes-material-apply-order-add.vue')
    },
    {
        'path': '/mes/apply/mes-material-apply-order',
        'name': 'mes/apply/mes-material-apply-order',
        'component': () => import('@/components/content/mes/apply/mes-material-apply-order.vue')
    },
    {
        'path': '/mes/apply/mes-material-apply-out-house',
        'name': 'mes/apply/mes-material-apply-out-house',
        'component': () => import('@/components/content/mes/apply/mes-material-apply-out-house.vue')
    },
    {
        'path': '/mes/bom/mes-product-bom-comparison',
        'name': 'mes/bom/mes-product-bom-comparison',
        'component': () => import('@/components/content/mes/bom/mes-product-bom-comparison.vue')
    },
    {
        'path': '/mes/bom/mes-product-bom-table-upload',
        'name': 'mes/bom/mes-product-bom-table-upload',
        'component': () => import('@/components/content/mes/bom/mes-product-bom-table-upload.vue')
    },
    {
        'path': '/mes/bom/mes-product-bom',
        'name': 'mes/bom/mes-product-bom',
        'component': () => import('@/components/content/mes/bom/mes-product-bom.vue')
    },
    {
        'path': '/mes/burn/mes-burn-basic',
        'name': 'mes/burn/mes-burn-basic',
        'component': () => import('@/components/content/mes/burn/mes-burn-basic.vue')
    },
    {
        'path': '/mes/burn/mes-burn-client',
        'name': 'mes/burn/mes-burn-client',
        'component': () => import('@/components/content/mes/burn/mes-burn-client.vue')
    },
    {
        'path': '/mes/burn/mes-burn-collect-log',
        'name': 'mes/burn/mes-burn-collect-log',
        'component': () => import('@/components/content/mes/burn/mes-burn-collect-log.vue')
    },
    {
        'path': '/mes/burn/mes-burn-execution',
        'name': 'mes/burn/mes-burn-execution',
        'component': () => import('@/components/content/mes/burn/mes-burn-execution.vue')
    },
    {
        'path': '/mes/burn/mes-burn-feeding-log',
        'name': 'mes/burn/mes-burn-feeding-log',
        'component': () => import('@/components/content/mes/burn/mes-burn-feeding-log.vue')
    },
    {
        'path': '/mes/burn/mes-burn-file-server',
        'name': 'mes/burn/mes-burn-file-server',
        'component': () => import('@/components/content/mes/burn/mes-burn-file-server.vue')
    },
    {
        'path': '/mes/burn/mes-burn-log',
        'name': 'mes/burn/mes-burn-log',
        'component': () => import('@/components/content/mes/burn/mes-burn-log.vue')
    },
    {
        'path': '/mes/burn/mes-burn-material-code',
        'name': 'mes/burn/mes-burn-material-code',
        'component': () => import('@/components/content/mes/burn/mes-burn-material-code.vue')
    },
    {
        'path': '/mes/burn/mes-burn-op-log',
        'name': 'mes/burn/mes-burn-op-log',
        'component': () => import('@/components/content/mes/burn/mes-burn-op-log.vue')
    },
    {
        'path': '/mes/burn/mes-burn-part-no-revert-log',
        'name': 'mes/burn/mes-burn-part-no-revert-log',
        'component': () => import('@/components/content/mes/burn/mes-burn-part-no-revert-log.vue')
    },
    {
        'path': '/mes/burn/mes-burn-part-no-revert',
        'name': 'mes/burn/mes-burn-part-no-revert',
        'component': () => import('@/components/content/mes/burn/mes-burn-part-no-revert.vue')
    },
    {
        'path': '/mes/burn/mes-burn-print-label-log',
        'name': 'mes/burn/mes-burn-print-label-log',
        'component': () => import('@/components/content/mes/burn/mes-burn-print-label-log.vue')
    },
    {
        'path': '/mes/burn/mes-burn-program',
        'name': 'mes/burn/mes-burn-program',
        'component': () => import('@/components/content/mes/burn/mes-burn-program.vue')
    },
    {
        'path': '/mes/burn/mes-burn-project',
        'name': 'mes/burn/mes-burn-project',
        'component': () => import('@/components/content/mes/burn/mes-burn-project.vue')
    },
    {
        'path': '/mes/burn/mes-burn-soft',
        'name': 'mes/burn/mes-burn-soft',
        'component': () => import('@/components/content/mes/burn/mes-burn-soft.vue')
    },
    {
        'path': '/mes/carrier/mes-sn-fifo-control',
        'name': 'mes/carrier/mes-sn-fifo-control',
        'component': () => import('@/components/content/mes/carrier/mes-sn-fifo-control.vue')
    },
    {
        'path': '/mes/check/addSpotCheckSn',
        'name': 'mes/check/addSpotCheckSn',
        'component': () => import('@/components/content/mes/check/addSpotCheckSn.vue')
    },
    {
        'path': '/mes/check/checkReport',
        'name': 'mes/check/checkReport',
        'component': () => import('@/components/content/mes/check/checkReport.vue')
    },
    {
        'path': '/mes/check/comp/check-config',
        'name': 'mes/check/comp/check-config',
        'component': () => import('@/components/content/mes/check/comp/check-config.vue')
    },
    {
        'path': '/mes/check/comp/check-input-column',
        'name': 'mes/check/comp/check-input-column',
        'component': () => import('@/components/content/mes/check/comp/check-input-column.vue')
    },
    {
        'path': '/mes/check/comp/check-input-table',
        'name': 'mes/check/comp/check-input-table',
        'component': () => import('@/components/content/mes/check/comp/check-input-table.vue')
    },
    {
        'path': '/mes/check/comp/check-input',
        'name': 'mes/check/comp/check-input',
        'component': () => import('@/components/content/mes/check/comp/check-input.vue')
    },
    {
        'path': '/mes/check/comp/check-preview',
        'name': 'mes/check/comp/check-preview',
        'component': () => import('@/components/content/mes/check/comp/check-preview.vue')
    },
    {
        'path': '/mes/check/comp/check-send',
        'name': 'mes/check/comp/check-send',
        'component': () => import('@/components/content/mes/check/comp/check-send.vue')
    },
    {
        'path': '/mes/check/comp/checkSnTestInfo',
        'name': 'mes/check/comp/checkSnTestInfo',
        'component': () => import('@/components/content/mes/check/comp/checkSnTestInfo.vue')
    },
    {
        'path': '/mes/check/comp/small-keyboard',
        'name': 'mes/check/comp/small-keyboard',
        'component': () => import('@/components/content/mes/check/comp/small-keyboard.vue')
    },
    {
        'path': '/mes/check/executeCheck',
        'name': 'mes/check/executeCheck',
        'component': () => import('@/components/content/mes/check/executeCheck.vue')
    },
    {
        'path': '/mes/check/spotCheckModule',
        'name': 'mes/check/spotCheckModule',
        'component': () => import('@/components/content/mes/check/spotCheckModule.vue')
    },
    {
        'path': '/mes/check/spotCheckRecord',
        'name': 'mes/check/spotCheckRecord',
        'component': () => import('@/components/content/mes/check/spotCheckRecord.vue')
    },
    {
        'path': '/mes/check/spotCheckSn',
        'name': 'mes/check/spotCheckSn',
        'component': () => import('@/components/content/mes/check/spotCheckSn.vue')
    },
    {
        'path': '/mes/control/mes-code-category-config',
        'name': 'mes/control/mes-code-category-config',
        'component': () => import('@/components/content/mes/control/mes-code-category-config.vue')
    },
    {
        'path': '/mes/control/mes-pattern-temp',
        'name': 'mes/control/mes-pattern-temp',
        'component': () => import('@/components/content/mes/control/mes-pattern-temp.vue')
    },
    {
        'path': '/mes/control/mes-product-process-control-config-new',
        'name': 'mes/control/mes-product-process-control-config-new',
        'component': () => import('@/components/content/mes/control/mes-product-process-control-config-new.vue')
    },
    {
        'path': '/mes/control/mes-product-process-control-config',
        'name': 'mes/control/mes-product-process-control-config',
        'component': () => import('@/components/content/mes/control/mes-product-process-control-config.vue')
    },
    {
        'path': '/mes/control/mes-product-process-control-copy',
        'name': 'mes/control/mes-product-process-control-copy',
        'component': () => import('@/components/content/mes/control/mes-product-process-control-copy.vue')
    },
    {
        'path': '/mes/epv/mes-alarm-log',
        'name': 'mes/epv/mes-alarm-log',
        'component': () => import('@/components/content/mes/epv/mes-alarm-log.vue')
    },
    {
        'path': '/mes/epv/mes-epv-collect-log',
        'name': 'mes/epv/mes-epv-collect-log',
        'component': () => import('@/components/content/mes/epv/mes-epv-collect-log.vue')
    },
    {
        'path': '/mes/epv/mes-epv-consume-error-log',
        'name': 'mes/epv/mes-epv-consume-error-log',
        'component': () => import('@/components/content/mes/epv/mes-epv-consume-error-log.vue')
    },
    {
        'path': '/mes/epv/mes-epv-material-sn-register',
        'name': 'mes/epv/mes-epv-material-sn-register',
        'component': () => import('@/components/content/mes/epv/mes-epv-material-sn-register.vue')
    },
    {
        'path': '/mes/epv/mes-epv-mounter-control',
        'name': 'mes/epv/mes-epv-mounter-control',
        'component': () => import('@/components/content/mes/epv/mes-epv-mounter-control.vue')
    },
    {
        'path': '/mes/epv/mes-epv-operate-log',
        'name': 'mes/epv/mes-epv-operate-log',
        'component': () => import('@/components/content/mes/epv/mes-epv-operate-log.vue')
    },
    {
        'path': '/mes/epv/mes-feeder-rel',
        'name': 'mes/epv/mes-feeder-rel',
        'component': () => import('@/components/content/mes/epv/mes-feeder-rel.vue')
    },
    {
        'path': '/mes/epv/mes-full-inspection-log',
        'name': 'mes/epv/mes-full-inspection-log',
        'component': () => import('@/components/content/mes/epv/mes-full-inspection-log.vue')
    },
    {
        'path': '/mes/epv/mes-low-level-warning',
        'name': 'mes/epv/mes-low-level-warning',
        'component': () => import('@/components/content/mes/epv/mes-low-level-warning.vue')
    },
    {
        'path': '/mes/epv/mes-material-avoid',
        'name': 'mes/epv/mes-material-avoid',
        'component': () => import('@/components/content/mes/epv/mes-material-avoid.vue')
    },
    {
        'path': '/mes/epv/mes-material-bind-log',
        'name': 'mes/epv/mes-material-bind-log',
        'component': () => import('@/components/content/mes/epv/mes-material-bind-log.vue')
    },
    {
        'path': '/mes/epv/mes-material-correct-qty',
        'name': 'mes/epv/mes-material-correct-qty',
        'component': () => import('@/components/content/mes/epv/mes-material-correct-qty.vue')
    },
    {
        'path': '/mes/epv/mes-material-error-log',
        'name': 'mes/epv/mes-material-error-log',
        'component': () => import('@/components/content/mes/epv/mes-material-error-log.vue')
    },
    {
        'path': '/mes/epv/mes-material-feeding-log',
        'name': 'mes/epv/mes-material-feeding-log',
        'component': () => import('@/components/content/mes/epv/mes-material-feeding-log.vue')
    },
    {
        'path': '/mes/epv/mes-panasonic-event-notify-log',
        'name': 'mes/epv/mes-panasonic-event-notify-log',
        'component': () => import('@/components/content/mes/epv/mes-panasonic-event-notify-log.vue')
    },
    {
        'path': '/mes/epv/mes-program-replace-part',
        'name': 'mes/epv/mes-program-replace-part',
        'component': () => import('@/components/content/mes/epv/mes-program-replace-part.vue')
    },
    {
        'path': '/mes/epv/mes-station-table-upload',
        'name': 'mes/epv/mes-station-table-upload',
        'component': () => import('@/components/content/mes/epv/mes-station-table-upload.vue')
    },
    {
        'path': '/mes/epv/mes-station-table',
        'name': 'mes/epv/mes-station-table',
        'component': () => import('@/components/content/mes/epv/mes-station-table.vue')
    },
    {
        'path': '/mes/epv/mes-throw-material-log',
        'name': 'mes/epv/mes-throw-material-log',
        'component': () => import('@/components/content/mes/epv/mes-throw-material-log.vue')
    },
    {
        'path': '/mes/equipment/mes-equipment-district-generation',
        'name': 'mes/equipment/mes-equipment-district-generation',
        'component': () => import('@/components/content/mes/equipment/mes-equipment-district-generation.vue')
    },
    {
        'path': '/mes/equipment/mes-equipment-district',
        'name': 'mes/equipment/mes-equipment-district',
        'component': () => import('@/components/content/mes/equipment/mes-equipment-district.vue')
    },
    {
        'path': '/mes/equipment/mes-equipment-model',
        'name': 'mes/equipment/mes-equipment-model',
        'component': () => import('@/components/content/mes/equipment/mes-equipment-model.vue')
    },
    {
        'path': '/mes/equipment/mes-equipment-station',
        'name': 'mes/equipment/mes-equipment-station',
        'component': () => import('@/components/content/mes/equipment/mes-equipment-station.vue')
    },
    {
        'path': '/mes/equipment/mes-equipment-type',
        'name': 'mes/equipment/mes-equipment-type',
        'component': () => import('@/components/content/mes/equipment/mes-equipment-type.vue')
    },
    {
        'path': '/mes/equipment/mes-equipment',
        'name': 'mes/equipment/mes-equipment',
        'component': () => import('@/components/content/mes/equipment/mes-equipment.vue')
    },
    {
        'path': '/mes/esop/sop-dis-play',
        'name': 'mes/esop/sop-dis-play',
        'component': () => import('@/components/content/mes/esop/sop-dis-play.vue')
    },
    {
        'path': '/mes/fqc/mes-fqc-inspect-plan',
        'name': 'mes/fqc/mes-fqc-inspect-plan',
        'component': () => import('@/components/content/mes/fqc/mes-fqc-inspect-plan.vue')
    },
    {
        'path': '/mes/fqc/mes-fqc-inspect-task',
        'name': 'mes/fqc/mes-fqc-inspect-task',
        'component': () => import('@/components/content/mes/fqc/mes-fqc-inspect-task.vue')
    },
    {
        'path': '/mes/ipqc/mes-ipqc-inspect-plan',
        'name': 'mes/ipqc/mes-ipqc-inspect-plan',
        'component': () => import('@/components/content/mes/ipqc/mes-ipqc-inspect-plan.vue')
    },
    {
        'path': '/mes/ipqc/mes-ipqc-inspect-task-add',
        'name': 'mes/ipqc/mes-ipqc-inspect-task-add',
        'component': () => import('@/components/content/mes/ipqc/mes-ipqc-inspect-task-add.vue')
    },
    {
        'path': '/mes/ipqc/mes-ipqc-inspect-task-view',
        'name': 'mes/ipqc/mes-ipqc-inspect-task-view',
        'component': () => import('@/components/content/mes/ipqc/mes-ipqc-inspect-task-view.vue')
    },
    {
        'path': '/mes/ipqc/mes-ipqc-inspect-task',
        'name': 'mes/ipqc/mes-ipqc-inspect-task',
        'component': () => import('@/components/content/mes/ipqc/mes-ipqc-inspect-task.vue')
    },
    {
        'path': '/mes/material/mes-material-sn-op-log',
        'name': 'mes/material/mes-material-sn-op-log',
        'component': () => import('@/components/content/mes/material/mes-material-sn-op-log.vue')
    },
    {
        'path': '/mes/material/mes-material-sn',
        'name': 'mes/material/mes-material-sn',
        'component': () => import('@/components/content/mes/material/mes-material-sn.vue')
    },
    {
        'path': '/mes/material/mes-material-stock',
        'name': 'mes/material/mes-material-stock',
        'component': () => import('@/components/content/mes/material/mes-material-stock.vue')
    },
    {
        'path': '/mes/material/mes-material-transfer-order-sn',
        'name': 'mes/material/mes-material-transfer-order-sn',
        'component': () => import('@/components/content/mes/material/mes-material-transfer-order-sn.vue')
    },
    {
        'path': '/mes/material/mes-material-transfer-order',
        'name': 'mes/material/mes-material-transfer-order',
        'component': () => import('@/components/content/mes/material/mes-material-transfer-order.vue')
    },
    {
        'path': '/mes/material/mes-material-usage-item',
        'name': 'mes/material/mes-material-usage-item',
        'component': () => import('@/components/content/mes/material/mes-material-usage-item.vue')
    },
    {
        'path': '/mes/module/mes-factory',
        'name': 'mes/module/mes-factory',
        'component': () => import('@/components/content/mes/module/mes-factory.vue')
    },
    {
        'path': '/mes/module/mes-line-uph',
        'name': 'mes/module/mes-line-uph',
        'component': () => import('@/components/content/mes/module/mes-line-uph.vue')
    },
    {
        'path': '/mes/module/mes-line',
        'name': 'mes/module/mes-line',
        'component': () => import('@/components/content/mes/module/mes-line.vue')
    },
    {
        'path': '/mes/module/mes-station',
        'name': 'mes/module/mes-station',
        'component': () => import('@/components/content/mes/module/mes-station.vue')
    },
    {
        'path': '/mes/module/mes-work-center',
        'name': 'mes/module/mes-work-center',
        'component': () => import('@/components/content/mes/module/mes-work-center.vue')
    },
    {
        'path': '/mes/module/mes-work-shop',
        'name': 'mes/module/mes-work-shop',
        'component': () => import('@/components/content/mes/module/mes-work-shop.vue')
    },
    {
        'path': '/mes/person/mes-post',
        'name': 'mes/person/mes-post',
        'component': () => import('@/components/content/mes/person/mes-post.vue')
    },
    {
        'path': '/mes/person/mes-station-sign-record',
        'name': 'mes/person/mes-station-sign-record',
        'component': () => import('@/components/content/mes/person/mes-station-sign-record.vue')
    },
    {
        'path': '/mes/person/mes-station-sign',
        'name': 'mes/person/mes-station-sign',
        'component': () => import('@/components/content/mes/person/mes-station-sign.vue')
    },
    {
        'path': '/mes/person/skill/mes-post-skill',
        'name': 'mes/person/skill/mes-post-skill',
        'component': () => import('@/components/content/mes/person/skill/mes-post-skill.vue')
    },
    {
        'path': '/mes/person/skill/mes-product-skill',
        'name': 'mes/person/skill/mes-product-skill',
        'component': () => import('@/components/content/mes/person/skill/mes-product-skill.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-assess-record',
        'name': 'mes/person/skill/mes-skill-assess-record',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-assess-record.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-assess',
        'name': 'mes/person/skill/mes-skill-assess',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-assess.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-category',
        'name': 'mes/person/skill/mes-skill-category',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-category.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-certification',
        'name': 'mes/person/skill/mes-skill-certification',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-certification.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-radar',
        'name': 'mes/person/skill/mes-skill-radar',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-radar.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-training-plan',
        'name': 'mes/person/skill/mes-skill-training-plan',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-training-plan.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-training-record-add',
        'name': 'mes/person/skill/mes-skill-training-record-add',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-training-record-add.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-training-record',
        'name': 'mes/person/skill/mes-skill-training-record',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-training-record.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-training-task-exec',
        'name': 'mes/person/skill/mes-skill-training-task-exec',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-training-task-exec.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-training-task',
        'name': 'mes/person/skill/mes-skill-training-task',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-training-task.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill-user-status',
        'name': 'mes/person/skill/mes-skill-user-status',
        'component': () => import('@/components/content/mes/person/skill/mes-skill-user-status.vue')
    },
    {
        'path': '/mes/person/skill/mes-skill',
        'name': 'mes/person/skill/mes-skill',
        'component': () => import('@/components/content/mes/person/skill/mes-skill.vue')
    },
    {
        'path': '/mes/process/mes-basic-process',
        'name': 'mes/process/mes-basic-process',
        'component': () => import('@/components/content/mes/process/mes-basic-process.vue')
    },
    {
        'path': '/mes/process/mes-process-flow-copy',
        'name': 'mes/process/mes-process-flow-copy',
        'component': () => import('@/components/content/mes/process/mes-process-flow-copy.vue')
    },
    {
        'path': '/mes/process/mes-process-flow',
        'name': 'mes/process/mes-process-flow',
        'component': () => import('@/components/content/mes/process/mes-process-flow.vue')
    },
    {
        'path': '/mes/process/mes-segment',
        'name': 'mes/process/mes-segment',
        'component': () => import('@/components/content/mes/process/mes-segment.vue')
    },
    {
        'path': '/mes/process/processManager/form/commonSetting',
        'name': 'mes/process/processManager/form/commonSetting',
        'component': () => import('@/components/content/mes/process/processManager/form/commonSetting.vue')
    },
    {
        'path': '/mes/process/processManager/form/connectingSetting',
        'name': 'mes/process/processManager/form/connectingSetting',
        'component': () => import('@/components/content/mes/process/processManager/form/connectingSetting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/code-setting',
        'name': 'mes/process/processManager/form/flags/code-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/code-setting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/defect-setting',
        'name': 'mes/process/processManager/form/flags/defect-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/defect-setting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/feeding-setting',
        'name': 'mes/process/processManager/form/flags/feeding-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/feeding-setting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/pack-setting',
        'name': 'mes/process/processManager/form/flags/pack-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/pack-setting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/program-setting',
        'name': 'mes/process/processManager/form/flags/program-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/program-setting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/skill-setting',
        'name': 'mes/process/processManager/form/flags/skill-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/skill-setting.vue')
    },
    {
        'path': '/mes/process/processManager/form/flags/test-setting',
        'name': 'mes/process/processManager/form/flags/test-setting',
        'component': () => import('@/components/content/mes/process/processManager/form/flags/test-setting.vue')
    },
    {
        'path': '/mes/process/processManager/mes-process-flow-design',
        'name': 'mes/process/processManager/mes-process-flow-design',
        'component': () => import('@/components/content/mes/process/processManager/mes-process-flow-design.vue')
    },
    {
        'path': '/mes/process/processManager/process-setting',
        'name': 'mes/process/processManager/process-setting',
        'component': () => import('@/components/content/mes/process/processManager/process-setting.vue')
    },
    {
        'path': '/mes/produce/back-station',
        'name': 'mes/produce/back-station',
        'component': () => import('@/components/content/mes/produce/back-station.vue')
    },
    {
        'path': '/mes/produce/comps/pass-station-frame',
        'name': 'mes/produce/comps/pass-station-frame',
        'component': () => import('@/components/content/mes/produce/comps/pass-station-frame.vue')
    },
    {
        'path': '/mes/produce/comps/pass-station-result',
        'name': 'mes/produce/comps/pass-station-result',
        'component': () => import('@/components/content/mes/produce/comps/pass-station-result.vue')
    },
    {
        'path': '/mes/produce/comps/pass-station-setup',
        'name': 'mes/produce/comps/pass-station-setup',
        'component': () => import('@/components/content/mes/produce/comps/pass-station-setup.vue')
    },
    {
        'path': '/mes/produce/comps/selectors/line-selector',
        'name': 'mes/produce/comps/selectors/line-selector',
        'component': () => import('@/components/content/mes/produce/comps/selectors/line-selector.vue')
    },
    {
        'path': '/mes/produce/comps/selectors/process-selector',
        'name': 'mes/produce/comps/selectors/process-selector',
        'component': () => import('@/components/content/mes/produce/comps/selectors/process-selector.vue')
    },
    {
        'path': '/mes/produce/comps/selectors/station-selector',
        'name': 'mes/produce/comps/selectors/station-selector',
        'component': () => import('@/components/content/mes/produce/comps/selectors/station-selector.vue')
    },
    {
        'path': '/mes/produce/comps/selectors/work-order-selector',
        'name': 'mes/produce/comps/selectors/work-order-selector',
        'component': () => import('@/components/content/mes/produce/comps/selectors/work-order-selector.vue')
    },
    {
        'path': '/mes/produce/comps/selectors/work-order-task-selector',
        'name': 'mes/produce/comps/selectors/work-order-task-selector',
        'component': () => import('@/components/content/mes/produce/comps/selectors/work-order-task-selector.vue')
    },
    {
        'path': '/mes/produce/entry-defect',
        'name': 'mes/produce/entry-defect',
        'component': () => import('@/components/content/mes/produce/entry-defect.vue')
    },
    {
        'path': '/mes/produce/mes-bt-bind',
        'name': 'mes/produce/mes-bt-bind',
        'component': () => import('@/components/content/mes/produce/mes-bt-bind.vue')
    },
    {
        'path': '/mes/produce/mes-online-vehicl-sn',
        'name': 'mes/produce/mes-online-vehicl-sn',
        'component': () => import('@/components/content/mes/produce/mes-online-vehicl-sn.vue')
    },
    {
        'path': '/mes/produce/mes-online-vehicl',
        'name': 'mes/produce/mes-online-vehicl',
        'component': () => import('@/components/content/mes/produce/mes-online-vehicl.vue')
    },
    {
        'path': '/mes/produce/mes-product-scrap',
        'name': 'mes/produce/mes-product-scrap',
        'component': () => import('@/components/content/mes/produce/mes-product-scrap.vue')
    },
    {
        'path': '/mes/produce/mes-work-order-sn-info',
        'name': 'mes/produce/mes-work-order-sn-info',
        'component': () => import('@/components/content/mes/produce/mes-work-order-sn-info.vue')
    },
    {
        'path': '/mes/produce/package-transfer-order',
        'name': 'mes/produce/package-transfer-order',
        'component': () => import('@/components/content/mes/produce/package-transfer-order.vue')
    },
    {
        'path': '/mes/produce/pass-station-batch-package',
        'name': 'mes/produce/pass-station-batch-package',
        'component': () => import('@/components/content/mes/produce/pass-station-batch-package.vue')
    },
    {
        'path': '/mes/produce/pass-station-feeding',
        'name': 'mes/produce/pass-station-feeding',
        'component': () => import('@/components/content/mes/produce/pass-station-feeding.vue')
    },
    {
        'path': '/mes/produce/pass-station-package',
        'name': 'mes/produce/pass-station-package',
        'component': () => import('@/components/content/mes/produce/pass-station-package.vue')
    },
    {
        'path': '/mes/produce/pass-station-repair',
        'name': 'mes/produce/pass-station-repair',
        'component': () => import('@/components/content/mes/produce/pass-station-repair.vue')
    },
    {
        'path': '/mes/produce/pass-station-serial-port',
        'name': 'mes/produce/pass-station-serial-port',
        'component': () => import('@/components/content/mes/produce/pass-station-serial-port.vue')
    },
    {
        'path': '/mes/produce/pass-station-skip',
        'name': 'mes/produce/pass-station-skip',
        'component': () => import('@/components/content/mes/produce/pass-station-skip.vue')
    },
    {
        'path': '/mes/produce/pass-station-testing',
        'name': 'mes/produce/pass-station-testing',
        'component': () => import('@/components/content/mes/produce/pass-station-testing.vue')
    },
    {
        'path': '/mes/produce/pass-station-weigh',
        'name': 'mes/produce/pass-station-weigh',
        'component': () => import('@/components/content/mes/produce/pass-station-weigh.vue')
    },
    {
        'path': '/mes/produce/pass-station',
        'name': 'mes/produce/pass-station',
        'component': () => import('@/components/content/mes/produce/pass-station.vue')
    },
    {
        'path': '/mes/produce/skip-collect',
        'name': 'mes/produce/skip-collect',
        'component': () => import('@/components/content/mes/produce/skip-collect.vue')
    },
    {
        'path': '/mes/product/mes-product-bom-analyze',
        'name': 'mes/product/mes-product-bom-analyze',
        'component': () => import('@/components/content/mes/product/mes-product-bom-analyze.vue')
    },
    {
        'path': '/mes/product/mes-product-bom-version',
        'name': 'mes/product/mes-product-bom-version',
        'component': () => import('@/components/content/mes/product/mes-product-bom-version.vue')
    },
    {
        'path': '/mes/product/mes-product-code-rule-ext',
        'name': 'mes/product/mes-product-code-rule-ext',
        'component': () => import('@/components/content/mes/product/mes-product-code-rule-ext.vue')
    },
    {
        'path': '/mes/product/mes-product-code-rule',
        'name': 'mes/product/mes-product-code-rule',
        'component': () => import('@/components/content/mes/product/mes-product-code-rule.vue')
    },
    {
        'path': '/mes/product/mes-product-ext-config',
        'name': 'mes/product/mes-product-ext-config',
        'component': () => import('@/components/content/mes/product/mes-product-ext-config.vue')
    },
    {
        'path': '/mes/product/mes-product-family',
        'name': 'mes/product/mes-product-family',
        'component': () => import('@/components/content/mes/product/mes-product-family.vue')
    },
    {
        'path': '/mes/product/mes-product-process-capacity',
        'name': 'mes/product/mes-product-process-capacity',
        'component': () => import('@/components/content/mes/product/mes-product-process-capacity.vue')
    },
    {
        'path': '/mes/product/mes-product-trace-config',
        'name': 'mes/product/mes-product-trace-config',
        'component': () => import('@/components/content/mes/product/mes-product-trace-config.vue')
    },
    {
        'path': '/mes/product/mes-product-type',
        'name': 'mes/product/mes-product-type',
        'component': () => import('@/components/content/mes/product/mes-product-type.vue')
    },
    {
        'path': '/mes/product/mes-product',
        'name': 'mes/product/mes-product',
        'component': () => import('@/components/content/mes/product/mes-product.vue')
    },
    {
        'path': '/mes/production-sn/work-order-code-sn-generate',
        'name': 'mes/production-sn/work-order-code-sn-generate',
        'component': () => import('@/components/content/mes/production-sn/work-order-code-sn-generate.vue')
    },
    {
        'path': '/mes/production-sn/work-order-code-sn-print',
        'name': 'mes/production-sn/work-order-code-sn-print',
        'component': () => import('@/components/content/mes/production-sn/work-order-code-sn-print.vue')
    },
    {
        'path': '/mes/production-sn/work-order-code-sn-upload',
        'name': 'mes/production-sn/work-order-code-sn-upload',
        'component': () => import('@/components/content/mes/production-sn/work-order-code-sn-upload.vue')
    },
    {
        'path': '/mes/production-sn/work-order-code-sn',
        'name': 'mes/production-sn/work-order-code-sn',
        'component': () => import('@/components/content/mes/production-sn/work-order-code-sn.vue')
    },
    {
        'path': '/mes/program/current-device-program-config',
        'name': 'mes/program/current-device-program-config',
        'component': () => import('@/components/content/mes/program/current-device-program-config.vue')
    },
    {
        'path': '/mes/program/device-program-params-config',
        'name': 'mes/program/device-program-params-config',
        'component': () => import('@/components/content/mes/program/device-program-params-config.vue')
    },
    {
        'path': '/mes/program/equipment-program-config-change-log',
        'name': 'mes/program/equipment-program-config-change-log',
        'component': () => import('@/components/content/mes/program/equipment-program-config-change-log.vue')
    },
    {
        'path': '/mes/program/product-program-config',
        'name': 'mes/program/product-program-config',
        'component': () => import('@/components/content/mes/program/product-program-config.vue')
    },
    {
        'path': '/mes/qtime/mes-qtime-config',
        'name': 'mes/qtime/mes-qtime-config',
        'component': () => import('@/components/content/mes/qtime/mes-qtime-config.vue')
    },
    {
        'path': '/mes/qtime/mes-qtime-trace',
        'name': 'mes/qtime/mes-qtime-trace',
        'component': () => import('@/components/content/mes/qtime/mes-qtime-trace.vue')
    },
    {
        'path': '/mes/repair/add-repair-order',
        'name': 'mes/repair/add-repair-order',
        'component': () => import('@/components/content/mes/repair/add-repair-order.vue')
    },
    {
        'path': '/mes/repair/batch-repair-task-exec',
        'name': 'mes/repair/batch-repair-task-exec',
        'component': () => import('@/components/content/mes/repair/batch-repair-task-exec.vue')
    },
    {
        'path': '/mes/repair/mes-repair-task',
        'name': 'mes/repair/mes-repair-task',
        'component': () => import('@/components/content/mes/repair/mes-repair-task.vue')
    },
    {
        'path': '/mes/repair/repair-point',
        'name': 'mes/repair/repair-point',
        'component': () => import('@/components/content/mes/repair/repair-point.vue')
    },
    {
        'path': '/mes/repair/repair-task-exec',
        'name': 'mes/repair/repair-task-exec',
        'component': () => import('@/components/content/mes/repair/repair-task-exec.vue')
    },
    {
        'path': '/mes/repair/repair-task-item',
        'name': 'mes/repair/repair-task-item',
        'component': () => import('@/components/content/mes/repair/repair-task-item.vue')
    },
    {
        'path': '/mes/repair/repair-task-refueling',
        'name': 'mes/repair/repair-task-refueling',
        'component': () => import('@/components/content/mes/repair/repair-task-refueling.vue')
    },
    {
        'path': '/mes/repair/repairRefuelling',
        'name': 'mes/repair/repairRefuelling',
        'component': () => import('@/components/content/mes/repair/repairRefuelling.vue')
    },
    {
        'path': '/mes/schedule/gantt-schdule/mes-work-schdule',
        'name': 'mes/schedule/gantt-schdule/mes-work-schdule',
        'component': () => import('@/components/content/mes/schedule/gantt-schdule/mes-work-schdule.vue')
    },
    {
        'path': '/mes/schedule/gantt-schdule/plan-info-left',
        'name': 'mes/schedule/gantt-schdule/plan-info-left',
        'component': () => import('@/components/content/mes/schedule/gantt-schdule/plan-info-left.vue')
    },
    {
        'path': '/mes/schedule/gantt-schdule/plan-info',
        'name': 'mes/schedule/gantt-schdule/plan-info',
        'component': () => import('@/components/content/mes/schedule/gantt-schdule/plan-info.vue')
    },
    {
        'path': '/mes/schedule/mes-product-rework-task',
        'name': 'mes/schedule/mes-product-rework-task',
        'component': () => import('@/components/content/mes/schedule/mes-product-rework-task.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-bom-log',
        'name': 'mes/schedule/mes-work-order-bom-log',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-bom-log.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-bom',
        'name': 'mes/schedule/mes-work-order-bom',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-bom.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-dispense',
        'name': 'mes/schedule/mes-work-order-dispense',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-dispense.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-line-change',
        'name': 'mes/schedule/mes-work-order-task-line-change',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-line-change.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-mrp-add',
        'name': 'mes/schedule/mes-work-order-task-mrp-add',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-mrp-add.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-mrp-view',
        'name': 'mes/schedule/mes-work-order-task-mrp-view',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-mrp-view.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-mrp',
        'name': 'mes/schedule/mes-work-order-task-mrp',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-mrp.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-rework-task',
        'name': 'mes/schedule/mes-work-order-task-rework-task',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-rework-task.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-split',
        'name': 'mes/schedule/mes-work-order-task-split',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-split.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task-track-change',
        'name': 'mes/schedule/mes-work-order-task-track-change',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task-track-change.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-task',
        'name': 'mes/schedule/mes-work-order-task',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-task.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order-transfer',
        'name': 'mes/schedule/mes-work-order-transfer',
        'component': () => import('@/components/content/mes/schedule/mes-work-order-transfer.vue')
    },
    {
        'path': '/mes/schedule/mes-work-order',
        'name': 'mes/schedule/mes-work-order',
        'component': () => import('@/components/content/mes/schedule/mes-work-order.vue')
    },
    {
        'path': '/mes/temp/mes-process-control-temp',
        'name': 'mes/temp/mes-process-control-temp',
        'component': () => import('@/components/content/mes/temp/mes-process-control-temp.vue')
    },
    {
        'path': '/mes/tools/check/mes-tool-check-item',
        'name': 'mes/tools/check/mes-tool-check-item',
        'component': () => import('@/components/content/mes/tools/check/mes-tool-check-item.vue')
    },
    {
        'path': '/mes/tools/mes-station-tool',
        'name': 'mes/tools/mes-station-tool',
        'component': () => import('@/components/content/mes/tools/mes-station-tool.vue')
    },
    {
        'path': '/mes/tools/mes-tool-acceptance',
        'name': 'mes/tools/mes-tool-acceptance',
        'component': () => import('@/components/content/mes/tools/mes-tool-acceptance.vue')
    },
    {
        'path': '/mes/tools/mes-tool-category',
        'name': 'mes/tools/mes-tool-category',
        'component': () => import('@/components/content/mes/tools/mes-tool-category.vue')
    },
    {
        'path': '/mes/tools/mes-tool-clean',
        'name': 'mes/tools/mes-tool-clean',
        'component': () => import('@/components/content/mes/tools/mes-tool-clean.vue')
    },
    {
        'path': '/mes/tools/mes-tool-entry-defect',
        'name': 'mes/tools/mes-tool-entry-defect',
        'component': () => import('@/components/content/mes/tools/mes-tool-entry-defect.vue')
    },
    {
        'path': '/mes/tools/mes-tool-in-house',
        'name': 'mes/tools/mes-tool-in-house',
        'component': () => import('@/components/content/mes/tools/mes-tool-in-house.vue')
    },
    {
        'path': '/mes/tools/mes-tool-inspection-plan',
        'name': 'mes/tools/mes-tool-inspection-plan',
        'component': () => import('@/components/content/mes/tools/mes-tool-inspection-plan.vue')
    },
    {
        'path': '/mes/tools/mes-tool-inspection',
        'name': 'mes/tools/mes-tool-inspection',
        'component': () => import('@/components/content/mes/tools/mes-tool-inspection.vue')
    },
    {
        'path': '/mes/tools/mes-tool-maintain-item',
        'name': 'mes/tools/mes-tool-maintain-item',
        'component': () => import('@/components/content/mes/tools/mes-tool-maintain-item.vue')
    },
    {
        'path': '/mes/tools/mes-tool-maintain-plan',
        'name': 'mes/tools/mes-tool-maintain-plan',
        'component': () => import('@/components/content/mes/tools/mes-tool-maintain-plan.vue')
    },
    {
        'path': '/mes/tools/mes-tool-maintain',
        'name': 'mes/tools/mes-tool-maintain',
        'component': () => import('@/components/content/mes/tools/mes-tool-maintain.vue')
    },
    {
        'path': '/mes/tools/mes-tool-model',
        'name': 'mes/tools/mes-tool-model',
        'component': () => import('@/components/content/mes/tools/mes-tool-model.vue')
    },
    {
        'path': '/mes/tools/mes-tool-need-maintain-list',
        'name': 'mes/tools/mes-tool-need-maintain-list',
        'component': () => import('@/components/content/mes/tools/mes-tool-need-maintain-list.vue')
    },
    {
        'path': '/mes/tools/mes-tool-operate-log',
        'name': 'mes/tools/mes-tool-operate-log',
        'component': () => import('@/components/content/mes/tools/mes-tool-operate-log.vue')
    },
    {
        'path': '/mes/tools/mes-tool-out-house',
        'name': 'mes/tools/mes-tool-out-house',
        'component': () => import('@/components/content/mes/tools/mes-tool-out-house.vue')
    },
    {
        'path': '/mes/tools/mes-tool-pe-inspection',
        'name': 'mes/tools/mes-tool-pe-inspection',
        'component': () => import('@/components/content/mes/tools/mes-tool-pe-inspection.vue')
    },
    {
        'path': '/mes/tools/mes-tool-recovery',
        'name': 'mes/tools/mes-tool-recovery',
        'component': () => import('@/components/content/mes/tools/mes-tool-recovery.vue')
    },
    {
        'path': '/mes/tools/mes-tool-register',
        'name': 'mes/tools/mes-tool-register',
        'component': () => import('@/components/content/mes/tools/mes-tool-register.vue')
    },
    {
        'path': '/mes/tools/mes-tool-repair-exec',
        'name': 'mes/tools/mes-tool-repair-exec',
        'component': () => import('@/components/content/mes/tools/mes-tool-repair-exec.vue')
    },
    {
        'path': '/mes/tools/mes-tool-repair',
        'name': 'mes/tools/mes-tool-repair',
        'component': () => import('@/components/content/mes/tools/mes-tool-repair.vue')
    },
    {
        'path': '/mes/tools/mes-tool-scrap',
        'name': 'mes/tools/mes-tool-scrap',
        'component': () => import('@/components/content/mes/tools/mes-tool-scrap.vue')
    },
    {
        'path': '/mes/tools/mes-tool-sn-generate',
        'name': 'mes/tools/mes-tool-sn-generate',
        'component': () => import('@/components/content/mes/tools/mes-tool-sn-generate.vue')
    },
    {
        'path': '/mes/tools/mes-tool-sn',
        'name': 'mes/tools/mes-tool-sn',
        'component': () => import('@/components/content/mes/tools/mes-tool-sn.vue')
    },
    {
        'path': '/mes/tools/mes-tool-transfer-cell',
        'name': 'mes/tools/mes-tool-transfer-cell',
        'component': () => import('@/components/content/mes/tools/mes-tool-transfer-cell.vue')
    },
    {
        'path': '/mes/trace/mes-container-product-trace',
        'name': 'mes/trace/mes-container-product-trace',
        'component': () => import('@/components/content/mes/trace/mes-container-product-trace.vue')
    },
    {
        'path': '/mes/trace/mes-container-split-log',
        'name': 'mes/trace/mes-container-split-log',
        'component': () => import('@/components/content/mes/trace/mes-container-split-log.vue')
    },
    {
        'path': '/mes/trace/mes-container-trace',
        'name': 'mes/trace/mes-container-trace',
        'component': () => import('@/components/content/mes/trace/mes-container-trace.vue')
    },
    {
        'path': '/mes/trace/mes-exit-station-log',
        'name': 'mes/trace/mes-exit-station-log',
        'component': () => import('@/components/content/mes/trace/mes-exit-station-log.vue')
    },
    {
        'path': '/mes/trace/mes-history-link/mes-history-link',
        'name': 'mes/trace/mes-history-link/mes-history-link',
        'component': () => import('@/components/content/mes/trace/mes-history-link/mes-history-link.vue')
    },
    {
        'path': '/mes/trace/mes-history-link/table/mes-history-link-item',
        'name': 'mes/trace/mes-history-link/table/mes-history-link-item',
        'component': () => import('@/components/content/mes/trace/mes-history-link/table/mes-history-link-item.vue')
    },
    {
        'path': '/mes/trace/mes-mac-pool-trace',
        'name': 'mes/trace/mes-mac-pool-trace',
        'component': () => import('@/components/content/mes/trace/mes-mac-pool-trace.vue')
    },
    {
        'path': '/mes/trace/mes-material-trace-log',
        'name': 'mes/trace/mes-material-trace-log',
        'component': () => import('@/components/content/mes/trace/mes-material-trace-log.vue')
    },
    {
        'path': '/mes/trace/mes-merge-box-log',
        'name': 'mes/trace/mes-merge-box-log',
        'component': () => import('@/components/content/mes/trace/mes-merge-box-log.vue')
    },
    {
        'path': '/mes/trace/mes-order-data-statistics',
        'name': 'mes/trace/mes-order-data-statistics',
        'component': () => import('@/components/content/mes/trace/mes-order-data-statistics.vue')
    },
    {
        'path': '/mes/trace/mes-order-task-data-statistics',
        'name': 'mes/trace/mes-order-task-data-statistics',
        'component': () => import('@/components/content/mes/trace/mes-order-task-data-statistics.vue')
    },
    {
        'path': '/mes/trace/mes-pass-station-log',
        'name': 'mes/trace/mes-pass-station-log',
        'component': () => import('@/components/content/mes/trace/mes-pass-station-log.vue')
    },
    {
        'path': '/mes/trace/mes-pass-station-lot-sn-log',
        'name': 'mes/trace/mes-pass-station-lot-sn-log',
        'component': () => import('@/components/content/mes/trace/mes-pass-station-lot-sn-log.vue')
    },
    {
        'path': '/mes/trace/mes-press-machine-log',
        'name': 'mes/trace/mes-press-machine-log',
        'component': () => import('@/components/content/mes/trace/mes-press-machine-log.vue')
    },
    {
        'path': '/mes/trace/mes-product-trace-alone',
        'name': 'mes/trace/mes-product-trace-alone',
        'component': () => import('@/components/content/mes/trace/mes-product-trace-alone.vue')
    },
    {
        'path': '/mes/trace/mes-product-trace',
        'name': 'mes/trace/mes-product-trace',
        'component': () => import('@/components/content/mes/trace/mes-product-trace.vue')
    },
    {
        'path': '/mes/trace/mes-resource-trace',
        'name': 'mes/trace/mes-resource-trace',
        'component': () => import('@/components/content/mes/trace/mes-resource-trace.vue')
    },
    {
        'path': '/mes/trace/mes-rework-task-log',
        'name': 'mes/trace/mes-rework-task-log',
        'component': () => import('@/components/content/mes/trace/mes-rework-task-log.vue')
    },
    {
        'path': '/mes/trace/mes-sn-package-log',
        'name': 'mes/trace/mes-sn-package-log',
        'component': () => import('@/components/content/mes/trace/mes-sn-package-log.vue')
    },
    {
        'path': '/mes/trace/mes-station-bind-log',
        'name': 'mes/trace/mes-station-bind-log',
        'component': () => import('@/components/content/mes/trace/mes-station-bind-log.vue')
    },
    {
        'path': '/mes/trace/mes-station-record',
        'name': 'mes/trace/mes-station-record',
        'component': () => import('@/components/content/mes/trace/mes-station-record.vue')
    },
    {
        'path': '/mes/trace/mes-test-image-missing-log',
        'name': 'mes/trace/mes-test-image-missing-log',
        'component': () => import('@/components/content/mes/trace/mes-test-image-missing-log.vue')
    },
    {
        'path': '/mes/trace/mes-test-log',
        'name': 'mes/trace/mes-test-log',
        'component': () => import('@/components/content/mes/trace/mes-test-log.vue')
    },
    {
        'path': '/mes/trace/mes-trace-process-param',
        'name': 'mes/trace/mes-trace-process-param',
        'component': () => import('@/components/content/mes/trace/mes-trace-process-param.vue')
    },
    {
        'path': '/mes/trace/mes-transfer-order-trace-log',
        'name': 'mes/trace/mes-transfer-order-trace-log',
        'component': () => import('@/components/content/mes/trace/mes-transfer-order-trace-log.vue')
    },
    {
        'path': '/mes/trace/mes-work-order-task-log',
        'name': 'mes/trace/mes-work-order-task-log',
        'component': () => import('@/components/content/mes/trace/mes-work-order-task-log.vue')
    },
    {
        'path': '/mes/trace/sn-info-trace',
        'name': 'mes/trace/sn-info-trace',
        'component': () => import('@/components/content/mes/trace/sn-info-trace.vue')
    },
    {
        'path': '/mes/workReport/product-work-report-order-register',
        'name': 'mes/workReport/product-work-report-order-register',
        'component': () => import('@/components/content/mes/workReport/product-work-report-order-register.vue')
    },
    {
        'path': '/mes/workReport/product-work-report-order',
        'name': 'mes/workReport/product-work-report-order',
        'component': () => import('@/components/content/mes/workReport/product-work-report-order.vue')
    },
    {
        'path': '/qms/basic/qms-basic-ureport-designer',
        'name': 'qms/basic/qms-basic-ureport-designer',
        'component': () => import('@/components/content/qms/basic/qms-basic-ureport-designer.vue')
    },
    {
        'path': '/qms/basic/qms-inspect-rule',
        'name': 'qms/basic/qms-inspect-rule',
        'component': () => import('@/components/content/qms/basic/qms-inspect-rule.vue')
    },
    {
        'path': '/qms/basic/qms-inspection-basis',
        'name': 'qms/basic/qms-inspection-basis',
        'component': () => import('@/components/content/qms/basic/qms-inspection-basis.vue')
    },
    {
        'path': '/qms/basic/qms-inspection-item-group',
        'name': 'qms/basic/qms-inspection-item-group',
        'component': () => import('@/components/content/qms/basic/qms-inspection-item-group.vue')
    },
    {
        'path': '/qms/basic/qms-inspection-item-standard',
        'name': 'qms/basic/qms-inspection-item-standard',
        'component': () => import('@/components/content/qms/basic/qms-inspection-item-standard.vue')
    },
    {
        'path': '/qms/basic/qms-inspection-item',
        'name': 'qms/basic/qms-inspection-item',
        'component': () => import('@/components/content/qms/basic/qms-inspection-item.vue')
    },
    {
        'path': '/qms/basic/qms-inspection-plan',
        'name': 'qms/basic/qms-inspection-plan',
        'component': () => import('@/components/content/qms/basic/qms-inspection-plan.vue')
    },
    {
        'path': '/qms/basic/qms-stringency-convert-log',
        'name': 'qms/basic/qms-stringency-convert-log',
        'component': () => import('@/components/content/qms/basic/qms-stringency-convert-log.vue')
    },
    {
        'path': '/qms/fqc/qms-inspection-fqc-order',
        'name': 'qms/fqc/qms-inspection-fqc-order',
        'component': () => import('@/components/content/qms/fqc/qms-inspection-fqc-order.vue')
    },
    {
        'path': '/qms/inspect/fqc/qms-inspect-fqc-info',
        'name': 'qms/inspect/fqc/qms-inspect-fqc-info',
        'component': () => import('@/components/content/qms/inspect/fqc/qms-inspect-fqc-info.vue')
    },
    {
        'path': '/qms/inspect/fqc/qms-inspect-fqc-plan-v2',
        'name': 'qms/inspect/fqc/qms-inspect-fqc-plan-v2',
        'component': () => import('@/components/content/qms/inspect/fqc/qms-inspect-fqc-plan-v2.vue')
    },
    {
        'path': '/qms/inspect/fqc/qms-inspect-fqc-plan',
        'name': 'qms/inspect/fqc/qms-inspect-fqc-plan',
        'component': () => import('@/components/content/qms/inspect/fqc/qms-inspect-fqc-plan.vue')
    },
    {
        'path': '/qms/inspect/ipqc/qms-inspect-ipqc-info',
        'name': 'qms/inspect/ipqc/qms-inspect-ipqc-info',
        'component': () => import('@/components/content/qms/inspect/ipqc/qms-inspect-ipqc-info.vue')
    },
    {
        'path': '/qms/inspect/ipqc/qms-inspect-ipqc-plan',
        'name': 'qms/inspect/ipqc/qms-inspect-ipqc-plan',
        'component': () => import('@/components/content/qms/inspect/ipqc/qms-inspect-ipqc-plan.vue')
    },
    {
        'path': '/qms/inspect/oqc/qms-inspect-oqc-info',
        'name': 'qms/inspect/oqc/qms-inspect-oqc-info',
        'component': () => import('@/components/content/qms/inspect/oqc/qms-inspect-oqc-info.vue')
    },
    {
        'path': '/qms/inspect/oqc/qms-inspect-oqc-plan-v2',
        'name': 'qms/inspect/oqc/qms-inspect-oqc-plan-v2',
        'component': () => import('@/components/content/qms/inspect/oqc/qms-inspect-oqc-plan-v2.vue')
    },
    {
        'path': '/qms/inspect/oqc/qms-inspect-oqc-plan',
        'name': 'qms/inspect/oqc/qms-inspect-oqc-plan',
        'component': () => import('@/components/content/qms/inspect/oqc/qms-inspect-oqc-plan.vue')
    },
    {
        'path': '/qms/inspect/oqc/qms-inspect-oqc',
        'name': 'qms/inspect/oqc/qms-inspect-oqc',
        'component': () => import('@/components/content/qms/inspect/oqc/qms-inspect-oqc.vue')
    },
    {
        'path': '/qms/inspect/qms-inspect-form',
        'name': 'qms/inspect/qms-inspect-form',
        'component': () => import('@/components/content/qms/inspect/qms-inspect-form.vue')
    },
    {
        'path': '/qms/inspect/qms-inspect-fqc',
        'name': 'qms/inspect/qms-inspect-fqc',
        'component': () => import('@/components/content/qms/inspect/qms-inspect-fqc.vue')
    },
    {
        'path': '/qms/inspect/qms-inspect-head',
        'name': 'qms/inspect/qms-inspect-head',
        'component': () => import('@/components/content/qms/inspect/qms-inspect-head.vue')
    },
    {
        'path': '/qms/inspect/qms-inspect-ipqc',
        'name': 'qms/inspect/qms-inspect-ipqc',
        'component': () => import('@/components/content/qms/inspect/qms-inspect-ipqc.vue')
    },
    {
        'path': '/qms/inspect/qms-inspect-tail',
        'name': 'qms/inspect/qms-inspect-tail',
        'component': () => import('@/components/content/qms/inspect/qms-inspect-tail.vue')
    },
    {
        'path': '/qms/ipqc/qms-inspection-ipqc-order',
        'name': 'qms/ipqc/qms-inspection-ipqc-order',
        'component': () => import('@/components/content/qms/ipqc/qms-inspection-ipqc-order.vue')
    },
    {
        'path': '/qms/ipqc/qms-inspection-ipqc-plan',
        'name': 'qms/ipqc/qms-inspection-ipqc-plan',
        'component': () => import('@/components/content/qms/ipqc/qms-inspection-ipqc-plan.vue')
    },
    {
        'path': '/qms/lcr-check',
        'name': 'qms/lcr-check',
        'component': () => import('@/components/content/qms/lcr-check.vue')
    },
    {
        'path': '/qms/notification/qms-notification-document-preview',
        'name': 'qms/notification/qms-notification-document-preview',
        'component': () => import('@/components/content/qms/notification/qms-notification-document-preview.vue')
    },
    {
        'path': '/qms/notification/qms-notification-document',
        'name': 'qms/notification/qms-notification-document',
        'component': () => import('@/components/content/qms/notification/qms-notification-document.vue')
    },
    {
        'path': '/qms/notification/qms-notification-type',
        'name': 'qms/notification/qms-notification-type',
        'component': () => import('@/components/content/qms/notification/qms-notification-type.vue')
    },
    {
        'path': '/qms/oqc/qms-inspection-oqc-order',
        'name': 'qms/oqc/qms-inspection-oqc-order',
        'component': () => import('@/components/content/qms/oqc/qms-inspection-oqc-order.vue')
    },
    {
        'path': '/qms/order/qms-inspection-order-choose',
        'name': 'qms/order/qms-inspection-order-choose',
        'component': () => import('@/components/content/qms/order/qms-inspection-order-choose.vue')
    },
    {
        'path': '/qms/order/qms-inspection-order-item-attach',
        'name': 'qms/order/qms-inspection-order-item-attach',
        'component': () => import('@/components/content/qms/order/qms-inspection-order-item-attach.vue')
    },
    {
        'path': '/qms/order/qms-inspection-order-register',
        'name': 'qms/order/qms-inspection-order-register',
        'component': () => import('@/components/content/qms/order/qms-inspection-order-register.vue')
    },
    {
        'path': '/qms/order/qms-inspection-order-update',
        'name': 'qms/order/qms-inspection-order-update',
        'component': () => import('@/components/content/qms/order/qms-inspection-order-update.vue')
    },
    {
        'path': '/qms/order/qms-inspection-order',
        'name': 'qms/order/qms-inspection-order',
        'component': () => import('@/components/content/qms/order/qms-inspection-order.vue')
    },
    {
        'path': '/qms/order/qms-inspection-validity-order',
        'name': 'qms/order/qms-inspection-validity-order',
        'component': () => import('@/components/content/qms/order/qms-inspection-validity-order.vue')
    },
    {
        'path': '/qms/qa/addQaSpotCheck',
        'name': 'qms/qa/addQaSpotCheck',
        'component': () => import('@/components/content/qms/qa/addQaSpotCheck.vue')
    },
    {
        'path': '/qms/qa/qaSpotCheck',
        'name': 'qms/qa/qaSpotCheck',
        'component': () => import('@/components/content/qms/qa/qaSpotCheck.vue')
    },
    {
        'path': '/qms/quarantine/qms-quarantine-order',
        'name': 'qms/quarantine/qms-quarantine-order',
        'component': () => import('@/components/content/qms/quarantine/qms-quarantine-order.vue')
    },
    {
        'path': '/qms/sampling/qms-sampling-plan',
        'name': 'qms/sampling/qms-sampling-plan',
        'component': () => import('@/components/content/qms/sampling/qms-sampling-plan.vue')
    },
    {
        'path': '/qms/standard/acceptance-quality-limit',
        'name': 'qms/standard/acceptance-quality-limit',
        'component': () => import('@/components/content/qms/standard/acceptance-quality-limit.vue')
    },
    {
        'path': '/qms/standard/aql',
        'name': 'qms/standard/aql',
        'component': () => import('@/components/content/qms/standard/aql.vue')
    },
    {
        'path': '/qms/standard/sample-code',
        'name': 'qms/standard/sample-code',
        'component': () => import('@/components/content/qms/standard/sample-code.vue')
    },
    {
        'path': '/qms/stringency/qms-stringency-convert-log',
        'name': 'qms/stringency/qms-stringency-convert-log',
        'component': () => import('@/components/content/qms/stringency/qms-stringency-convert-log.vue')
    },
    {
        'path': '/qms/stringency/qms-stringency-convert-rule',
        'name': 'qms/stringency/qms-stringency-convert-rule',
        'component': () => import('@/components/content/qms/stringency/qms-stringency-convert-rule.vue')
    },
    {
        'path': '/qms/stringency/qms-stringency',
        'name': 'qms/stringency/qms-stringency',
        'component': () => import('@/components/content/qms/stringency/qms-stringency.vue')
    },
    {
        'path': '/qms/todo/mrb-todo',
        'name': 'qms/todo/mrb-todo',
        'component': () => import('@/components/content/qms/todo/mrb-todo.vue')
    },
    {
        'path': '/qms/todo/purchase-todo',
        'name': 'qms/todo/purchase-todo',
        'component': () => import('@/components/content/qms/todo/purchase-todo.vue')
    },
    {
        'path': '/qms/todo/sqe-todo',
        'name': 'qms/todo/sqe-todo',
        'component': () => import('@/components/content/qms/todo/sqe-todo.vue')
    },
    {
        'path': '/qms/todo/technical-todo',
        'name': 'qms/todo/technical-todo',
        'component': () => import('@/components/content/qms/todo/technical-todo.vue')
    },
    {
        'path': '/report/data/direct-rate/mg-data-direct-rate-statistics',
        'name': 'report/data/direct-rate/mg-data-direct-rate-statistics',
        'component': () => import('@/components/content/report/data/direct-rate/mg-data-direct-rate-statistics.vue')
    },
    {
        'path': '/report/data/direct-rate/mo-data-direct-rate-statistics',
        'name': 'report/data/direct-rate/mo-data-direct-rate-statistics',
        'component': () => import('@/components/content/report/data/direct-rate/mo-data-direct-rate-statistics.vue')
    },
    {
        'path': '/report/data/material/data-solder-record',
        'name': 'report/data/material/data-solder-record',
        'component': () => import('@/components/content/report/data/material/data-solder-record.vue')
    },
    {
        'path': '/report/data/postback/data-conversion-rule',
        'name': 'report/data/postback/data-conversion-rule',
        'component': () => import('@/components/content/report/data/postback/data-conversion-rule.vue')
    },
    {
        'path': '/report/data/postback/data-postback-config',
        'name': 'report/data/postback/data-postback-config',
        'component': () => import('@/components/content/report/data/postback/data-postback-config.vue')
    },
    {
        'path': '/report/data/postback/data-postback-recod',
        'name': 'report/data/postback/data-postback-recod',
        'component': () => import('@/components/content/report/data/postback/data-postback-recod.vue')
    },
    {
        'path': '/report/data/process/data-process-parameters',
        'name': 'report/data/process/data-process-parameters',
        'component': () => import('@/components/content/report/data/process/data-process-parameters.vue')
    },
    {
        'path': '/report/data/pull/data-pull-record',
        'name': 'report/data/pull/data-pull-record',
        'component': () => import('@/components/content/report/data/pull/data-pull-record.vue')
    },
    {
        'path': '/report/data/repair/mg-data-repair-order-record',
        'name': 'report/data/repair/mg-data-repair-order-record',
        'component': () => import('@/components/content/report/data/repair/mg-data-repair-order-record.vue')
    },
    {
        'path': '/report/data/repair/mo-data-repair-order-record',
        'name': 'report/data/repair/mo-data-repair-order-record',
        'component': () => import('@/components/content/report/data/repair/mo-data-repair-order-record.vue')
    },
    {
        'path': '/report/data/spc/spc-control-chart-data',
        'name': 'report/data/spc/spc-control-chart-data',
        'component': () => import('@/components/content/report/data/spc/spc-control-chart-data.vue')
    },
    {
        'path': '/report/data/spc/spc-control-chart',
        'name': 'report/data/spc/spc-control-chart',
        'component': () => import('@/components/content/report/data/spc/spc-control-chart.vue')
    },
    {
        'path': '/report/data/spc/spc-control-config',
        'name': 'report/data/spc/spc-control-config',
        'component': () => import('@/components/content/report/data/spc/spc-control-config.vue')
    },
    {
        'path': '/report/data/spc/spc-frame',
        'name': 'report/data/spc/spc-frame',
        'component': () => import('@/components/content/report/data/spc/spc-frame.vue')
    },
    {
        'path': '/report/data/spc/spc-ooc-exception-data',
        'name': 'report/data/spc/spc-ooc-exception-data',
        'component': () => import('@/components/content/report/data/spc/spc-ooc-exception-data.vue')
    },
    {
        'path': '/report/data/spc/spc-ooc-monitor-chart',
        'name': 'report/data/spc/spc-ooc-monitor-chart',
        'component': () => import('@/components/content/report/data/spc/spc-ooc-monitor-chart.vue')
    },
    {
        'path': '/report/data/spc/spc-ooc-monitor-list',
        'name': 'report/data/spc/spc-ooc-monitor-list',
        'component': () => import('@/components/content/report/data/spc/spc-ooc-monitor-list.vue')
    },
    {
        'path': '/report/data/spc/spc-ooc-report',
        'name': 'report/data/spc/spc-ooc-report',
        'component': () => import('@/components/content/report/data/spc/spc-ooc-report.vue')
    },
    {
        'path': '/report/data/spc/spc-ppk-monitor-chart',
        'name': 'report/data/spc/spc-ppk-monitor-chart',
        'component': () => import('@/components/content/report/data/spc/spc-ppk-monitor-chart.vue')
    },
    {
        'path': '/report/data/spc/spc-ppk-monitor-data',
        'name': 'report/data/spc/spc-ppk-monitor-data',
        'component': () => import('@/components/content/report/data/spc/spc-ppk-monitor-data.vue')
    },
    {
        'path': '/report/data/spc/spc-ppk-monitor-list',
        'name': 'report/data/spc/spc-ppk-monitor-list',
        'component': () => import('@/components/content/report/data/spc/spc-ppk-monitor-list.vue')
    },
    {
        'path': '/report/data/spc/spc-ppk-report',
        'name': 'report/data/spc/spc-ppk-report',
        'component': () => import('@/components/content/report/data/spc/spc-ppk-report.vue')
    },
    {
        'path': '/report/data/spc/spc-process-analysis-list',
        'name': 'report/data/spc/spc-process-analysis-list',
        'component': () => import('@/components/content/report/data/spc/spc-process-analysis-list.vue')
    },
    {
        'path': '/report/data/spc/spc-product-control-chart',
        'name': 'report/data/spc/spc-product-control-chart',
        'component': () => import('@/components/content/report/data/spc/spc-product-control-chart.vue')
    },
    {
        'path': '/report/data/spc/spc-report',
        'name': 'report/data/spc/spc-report',
        'component': () => import('@/components/content/report/data/spc/spc-report.vue')
    },
    {
        'path': '/report/data/spc/spc-xr-data',
        'name': 'report/data/spc/spc-xr-data',
        'component': () => import('@/components/content/report/data/spc/spc-xr-data.vue')
    },
    {
        'path': '/report/data/tool/data-scraper-record',
        'name': 'report/data/tool/data-scraper-record',
        'component': () => import('@/components/content/report/data/tool/data-scraper-record.vue')
    },
    {
        'path': '/report/data/tool/data-steel-record',
        'name': 'report/data/tool/data-steel-record',
        'component': () => import('@/components/content/report/data/tool/data-steel-record.vue')
    },
    {
        'path': '/report/data/trace/mg-data-material-use-record',
        'name': 'report/data/trace/mg-data-material-use-record',
        'component': () => import('@/components/content/report/data/trace/mg-data-material-use-record.vue')
    },
    {
        'path': '/report/data/trace/mg-data-pass-station-record',
        'name': 'report/data/trace/mg-data-pass-station-record',
        'component': () => import('@/components/content/report/data/trace/mg-data-pass-station-record.vue')
    },
    {
        'path': '/report/data/trace/mg-data-test-record',
        'name': 'report/data/trace/mg-data-test-record',
        'component': () => import('@/components/content/report/data/trace/mg-data-test-record.vue')
    },
    {
        'path': '/report/data/trace/mo-data-material-use-record',
        'name': 'report/data/trace/mo-data-material-use-record',
        'component': () => import('@/components/content/report/data/trace/mo-data-material-use-record.vue')
    },
    {
        'path': '/report/data/trace/mo-data-pass-station-record',
        'name': 'report/data/trace/mo-data-pass-station-record',
        'component': () => import('@/components/content/report/data/trace/mo-data-pass-station-record.vue')
    },
    {
        'path': '/report/data/trace/mo-data-test-record',
        'name': 'report/data/trace/mo-data-test-record',
        'component': () => import('@/components/content/report/data/trace/mo-data-test-record.vue')
    },
    {
        'path': '/report/data/warn/warn-config',
        'name': 'report/data/warn/warn-config',
        'component': () => import('@/components/content/report/data/warn/warn-config.vue')
    },
    {
        'path': '/report/data/warn/warn-record-add',
        'name': 'report/data/warn/warn-record-add',
        'component': () => import('@/components/content/report/data/warn/warn-record-add.vue')
    },
    {
        'path': '/report/data/warn/warn-record',
        'name': 'report/data/warn/warn-record',
        'component': () => import('@/components/content/report/data/warn/warn-record.vue')
    },
    {
        'path': '/report/data/warn/warn-report',
        'name': 'report/data/warn/warn-report',
        'component': () => import('@/components/content/report/data/warn/warn-report.vue')
    },
    {
        'path': '/report/edi/data-conversion-rule',
        'name': 'report/edi/data-conversion-rule',
        'component': () => import('@/components/content/report/edi/data-conversion-rule.vue')
    },
    {
        'path': '/report/edi/data-postback-config',
        'name': 'report/edi/data-postback-config',
        'component': () => import('@/components/content/report/edi/data-postback-config.vue')
    },
    {
        'path': '/report/edi/data-postback-record',
        'name': 'report/edi/data-postback-record',
        'component': () => import('@/components/content/report/edi/data-postback-record.vue')
    },
    {
        'path': '/report/edi/data-pull-record',
        'name': 'report/edi/data-pull-record',
        'component': () => import('@/components/content/report/edi/data-pull-record.vue')
    },
    {
        'path': '/report/edi/material-use-record',
        'name': 'report/edi/material-use-record',
        'component': () => import('@/components/content/report/edi/material-use-record.vue')
    },
    {
        'path': '/report/edi/process-parameter-record',
        'name': 'report/edi/process-parameter-record',
        'component': () => import('@/components/content/report/edi/process-parameter-record.vue')
    },
    {
        'path': '/report/edi/repair-order-record',
        'name': 'report/edi/repair-order-record',
        'component': () => import('@/components/content/report/edi/repair-order-record.vue')
    },
    {
        'path': '/report/edi/test-record',
        'name': 'report/edi/test-record',
        'component': () => import('@/components/content/report/edi/test-record.vue')
    },
    {
        'path': '/report/iot/equipment-board-frame',
        'name': 'report/iot/equipment-board-frame',
        'component': () => import('@/components/content/report/iot/equipment-board-frame.vue')
    },
    {
        'path': '/report/iot/equipment-monitoring',
        'name': 'report/iot/equipment-monitoring',
        'component': () => import('@/components/content/report/iot/equipment-monitoring.vue')
    },
    {
        'path': '/report/iot/equipment-oee-monitoring',
        'name': 'report/iot/equipment-oee-monitoring',
        'component': () => import('@/components/content/report/iot/equipment-oee-monitoring.vue')
    },
    {
        'path': '/report/iot/equipment-run-status-report',
        'name': 'report/iot/equipment-run-status-report',
        'component': () => import('@/components/content/report/iot/equipment-run-status-report.vue')
    },
    {
        'path': '/report/mes/wip/work-in-progress',
        'name': 'report/mes/wip/work-in-progress',
        'component': () => import('@/components/content/report/mes/wip/work-in-progress.vue')
    },
    {
        'path': '/report/production/test-report-list',
        'name': 'report/production/test-report-list',
        'component': () => import('@/components/content/report/production/test-report-list.vue')
    },
    {
        'path': '/report/production/test-report-listV2',
        'name': 'report/production/test-report-listV2',
        'component': () => import('@/components/content/report/production/test-report-listV2.vue')
    },
    {
        'path': '/report/production/test-report-viewV2',
        'name': 'report/production/test-report-viewV2',
        'component': () => import('@/components/content/report/production/test-report-viewV2.vue')
    },
    {
        'path': '/report/production/transit-statistics-list',
        'name': 'report/production/transit-statistics-list',
        'component': () => import('@/components/content/report/production/transit-statistics-list.vue')
    },
    {
        'path': '/report/production/wip/process-statistics',
        'name': 'report/production/wip/process-statistics',
        'component': () => import('@/components/content/report/production/wip/process-statistics.vue')
    },
    {
        'path': '/report/production/wip/work-in-progress-detail-v2',
        'name': 'report/production/wip/work-in-progress-detail-v2',
        'component': () => import('@/components/content/report/production/wip/work-in-progress-detail-v2.vue')
    },
    {
        'path': '/report/production/wip/work-in-progress-detail-v3',
        'name': 'report/production/wip/work-in-progress-detail-v3',
        'component': () => import('@/components/content/report/production/wip/work-in-progress-detail-v3.vue')
    },
    {
        'path': '/report/production/wip/work-in-progress-list-v2',
        'name': 'report/production/wip/work-in-progress-list-v2',
        'component': () => import('@/components/content/report/production/wip/work-in-progress-list-v2.vue')
    },
    {
        'path': '/report/production/wip/work-in-progress-list-v3',
        'name': 'report/production/wip/work-in-progress-list-v3',
        'component': () => import('@/components/content/report/production/wip/work-in-progress-list-v3.vue')
    },
    {
        'path': '/report/production/work-in-progress-detail-fail-sn',
        'name': 'report/production/work-in-progress-detail-fail-sn',
        'component': () => import('@/components/content/report/production/work-in-progress-detail-fail-sn.vue')
    },
    {
        'path': '/report/production/work-in-progress-detail-sn-v3',
        'name': 'report/production/work-in-progress-detail-sn-v3',
        'component': () => import('@/components/content/report/production/work-in-progress-detail-sn-v3.vue')
    },
    {
        'path': '/report/production/work-in-progress-detail-sn',
        'name': 'report/production/work-in-progress-detail-sn',
        'component': () => import('@/components/content/report/production/work-in-progress-detail-sn.vue')
    },
    {
        'path': '/report/production/work-in-progress-list',
        'name': 'report/production/work-in-progress-list',
        'component': () => import('@/components/content/report/production/work-in-progress-list.vue')
    },
    {
        'path': '/report/production/work-progress-list',
        'name': 'report/production/work-progress-list',
        'component': () => import('@/components/content/report/production/work-progress-list.vue')
    },
    {
        'path': '/report/qms/lot-pass-rate-view',
        'name': 'report/qms/lot-pass-rate-view',
        'component': () => import('@/components/content/report/qms/lot-pass-rate-view.vue')
    },
    {
        'path': '/report/qms/pass-rate-view',
        'name': 'report/qms/pass-rate-view',
        'component': () => import('@/components/content/report/qms/pass-rate-view.vue')
    },
    {
        'path': '/report/report-management',
        'name': 'report/report-management',
        'component': () => import('@/components/content/report/report-management.vue')
    },
    {
        'path': '/report/report-search-condition',
        'name': 'report/report-search-condition',
        'component': () => import('@/components/content/report/report-search-condition.vue')
    },
    {
        'path': '/report/report-type',
        'name': 'report/report-type',
        'component': () => import('@/components/content/report/report-type.vue')
    },
    {
        'path': '/report/report-view',
        'name': 'report/report-view',
        'component': () => import('@/components/content/report/report-view.vue')
    },
    {
        'path': '/report/sales/sales-order-cost',
        'name': 'report/sales/sales-order-cost',
        'component': () => import('@/components/content/report/sales/sales-order-cost.vue')
    },
    {
        'path': '/report/sales/sales-order-list',
        'name': 'report/sales/sales-order-list',
        'component': () => import('@/components/content/report/sales/sales-order-list.vue')
    },
    {
        'path': '/report/wms/loss-report',
        'name': 'report/wms/loss-report',
        'component': () => import('@/components/content/report/wms/loss-report.vue')
    },
    {
        'path': '/report/wms/work-issue-report',
        'name': 'report/wms/work-issue-report',
        'component': () => import('@/components/content/report/wms/work-issue-report.vue')
    },
    {
        'path': '/srm/delivery/srm-delivery-order-out',
        'name': 'srm/delivery/srm-delivery-order-out',
        'component': () => import('@/components/content/srm/delivery/srm-delivery-order-out.vue')
    },
    {
        'path': '/srm/delivery/srm-delivery-order',
        'name': 'srm/delivery/srm-delivery-order',
        'component': () => import('@/components/content/srm/delivery/srm-delivery-order.vue')
    },
    {
        'path': '/srm/delivery/srm-material-delivery',
        'name': 'srm/delivery/srm-material-delivery',
        'component': () => import('@/components/content/srm/delivery/srm-material-delivery.vue')
    },
    {
        'path': '/srm/material/srm-material-pack-adjust',
        'name': 'srm/material/srm-material-pack-adjust',
        'component': () => import('@/components/content/srm/material/srm-material-pack-adjust.vue')
    },
    {
        'path': '/srm/material/srm-material-pack',
        'name': 'srm/material/srm-material-pack',
        'component': () => import('@/components/content/srm/material/srm-material-pack.vue')
    },
    {
        'path': '/srm/material/srm-material-sn-list',
        'name': 'srm/material/srm-material-sn-list',
        'component': () => import('@/components/content/srm/material/srm-material-sn-list.vue')
    },
    {
        'path': '/srm/purchase/srm-purchase-order-list',
        'name': 'srm/purchase/srm-purchase-order-list',
        'component': () => import('@/components/content/srm/purchase/srm-purchase-order-list.vue')
    },
    {
        'path': '/srm/purchase/srm-purchase-order-register',
        'name': 'srm/purchase/srm-purchase-order-register',
        'component': () => import('@/components/content/srm/purchase/srm-purchase-order-register.vue')
    },
    {
        'path': '/system/edi/edi-log',
        'name': 'system/edi/edi-log',
        'component': () => import('@/components/content/system/edi/edi-log.vue')
    },
    {
        'path': '/system/job/job-info',
        'name': 'system/job/job-info',
        'component': () => import('@/components/content/system/job/job-info.vue')
    },
    {
        'path': '/system/job/job-log',
        'name': 'system/job/job-log',
        'component': () => import('@/components/content/system/job/job-log.vue')
    },
    {
        'path': '/system/job/job-server',
        'name': 'system/job/job-server',
        'component': () => import('@/components/content/system/job/job-server.vue')
    },
    {
        'path': '/system/job/job-task-execution-record',
        'name': 'system/job/job-task-execution-record',
        'component': () => import('@/components/content/system/job/job-task-execution-record.vue')
    },
    {
        'path': '/system/message/message-templates',
        'name': 'system/message/message-templates',
        'component': () => import('@/components/content/system/message/message-templates.vue')
    },
    {
        'path': '/system/message/notice',
        'name': 'system/message/notice',
        'component': () => import('@/components/content/system/message/notice.vue')
    },
    {
        'path': '/system/ops/api-log',
        'name': 'system/ops/api-log',
        'component': () => import('@/components/content/system/ops/api-log.vue')
    },
    {
        'path': '/system/ops/error-log',
        'name': 'system/ops/error-log',
        'component': () => import('@/components/content/system/ops/error-log.vue')
    },
    {
        'path': '/system/ops/usual-log',
        'name': 'system/ops/usual-log',
        'component': () => import('@/components/content/system/ops/usual-log.vue')
    },
    {
        'path': '/system/permission/api-scope-config',
        'name': 'system/permission/api-scope-config',
        'component': () => import('@/components/content/system/permission/api-scope-config.vue')
    },
    {
        'path': '/system/permission/api-scope',
        'name': 'system/permission/api-scope',
        'component': () => import('@/components/content/system/permission/api-scope.vue')
    },
    {
        'path': '/system/permission/auth-client',
        'name': 'system/permission/auth-client',
        'component': () => import('@/components/content/system/permission/auth-client.vue')
    },
    {
        'path': '/system/permission/data-scope-config',
        'name': 'system/permission/data-scope-config',
        'component': () => import('@/components/content/system/permission/data-scope-config.vue')
    },
    {
        'path': '/system/permission/data-scope',
        'name': 'system/permission/data-scope',
        'component': () => import('@/components/content/system/permission/data-scope.vue')
    },
    {
        'path': '/system/permission/org-scope',
        'name': 'system/permission/org-scope',
        'component': () => import('@/components/content/system/permission/org-scope.vue')
    },
    {
        'path': '/system/permission/role-permission',
        'name': 'system/permission/role-permission',
        'component': () => import('@/components/content/system/permission/role-permission.vue')
    },
    {
        'path': '/system/permission/role',
        'name': 'system/permission/role',
        'component': () => import('@/components/content/system/permission/role.vue')
    },
    {
        'path': '/system/resource/ai-tool',
        'name': 'system/resource/ai-tool',
        'component': () => import('@/components/content/system/resource/ai-tool.vue')
    },
    {
        'path': '/system/resource/attach-manager',
        'name': 'system/resource/attach-manager',
        'component': () => import('@/components/content/system/resource/attach-manager.vue')
    },
    {
        'path': '/system/resource/databasedic',
        'name': 'system/resource/databasedic',
        'component': () => import('@/components/content/system/resource/databasedic.vue')
    },
    {
        'path': '/system/resource/file-download',
        'name': 'system/resource/file-download',
        'component': () => import('@/components/content/system/resource/file-download.vue')
    },
    {
        'path': '/system/resource/message-channel',
        'name': 'system/resource/message-channel',
        'component': () => import('@/components/content/system/resource/message-channel.vue')
    },
    {
        'path': '/system/resource/message-push-log',
        'name': 'system/resource/message-push-log',
        'component': () => import('@/components/content/system/resource/message-push-log.vue')
    },
    {
        'path': '/system/resource/message-push-rule-debug',
        'name': 'system/resource/message-push-rule-debug',
        'component': () => import('@/components/content/system/resource/message-push-rule-debug.vue')
    },
    {
        'path': '/system/resource/message-push-rule-test-simple',
        'name': 'system/resource/message-push-rule-test-simple',
        'component': () => import('@/components/content/system/resource/message-push-rule-test-simple.vue')
    },
    {
        'path': '/system/resource/message-push-rule',
        'name': 'system/resource/message-push-rule',
        'component': () => import('@/components/content/system/resource/message-push-rule.vue')
    },
    {
        'path': '/system/resource/message-push-test',
        'name': 'system/resource/message-push-test',
        'component': () => import('@/components/content/system/resource/message-push-test.vue')
    },
    {
        'path': '/system/resource/message-send-log',
        'name': 'system/resource/message-send-log',
        'component': () => import('@/components/content/system/resource/message-send-log.vue')
    },
    {
        'path': '/system/resource/message-template',
        'name': 'system/resource/message-template',
        'component': () => import('@/components/content/system/resource/message-template.vue')
    },
    {
        'path': '/system/resource/oss-debug',
        'name': 'system/resource/oss-debug',
        'component': () => import('@/components/content/system/resource/oss-debug.vue')
    },
    {
        'path': '/system/resource/oss',
        'name': 'system/resource/oss',
        'component': () => import('@/components/content/system/resource/oss.vue')
    },
    {
        'path': '/system/resource/websocket-cluster-manager',
        'name': 'system/resource/websocket-cluster-manager',
        'component': () => import('@/components/content/system/resource/websocket-cluster-manager.vue')
    },
    {
        'path': '/system/setting/dept',
        'name': 'system/setting/dept',
        'component': () => import('@/components/content/system/setting/dept.vue')
    },
    {
        'path': '/system/setting/i18n-encoding',
        'name': 'system/setting/i18n-encoding',
        'component': () => import('@/components/content/system/setting/i18n-encoding.vue')
    },
    {
        'path': '/system/setting/i18n-resources',
        'name': 'system/setting/i18n-resources',
        'component': () => import('@/components/content/system/setting/i18n-resources.vue')
    },
    {
        'path': '/system/setting/menu',
        'name': 'system/setting/menu',
        'component': () => import('@/components/content/system/setting/menu.vue')
    },
    {
        'path': '/system/setting/organization',
        'name': 'system/setting/organization',
        'component': () => import('@/components/content/system/setting/organization.vue')
    },
    {
        'path': '/system/setting/post',
        'name': 'system/setting/post',
        'component': () => import('@/components/content/system/setting/post.vue')
    },
    {
        'path': '/system/setting/tenant-authorize',
        'name': 'system/setting/tenant-authorize',
        'component': () => import('@/components/content/system/setting/tenant-authorize.vue')
    },
    {
        'path': '/system/setting/tenant-data-init',
        'name': 'system/setting/tenant-data-init',
        'component': () => import('@/components/content/system/setting/tenant-data-init.vue')
    },
    {
        'path': '/system/setting/tenant-datasource',
        'name': 'system/setting/tenant-datasource',
        'component': () => import('@/components/content/system/setting/tenant-datasource.vue')
    },
    {
        'path': '/system/setting/tenant',
        'name': 'system/setting/tenant',
        'component': () => import('@/components/content/system/setting/tenant.vue')
    },
    {
        'path': '/system/setting/user',
        'name': 'system/setting/user',
        'component': () => import('@/components/content/system/setting/user.vue')
    },
    {
        'path': '/system/strategy/csr-data-transfer-config-list',
        'name': 'system/strategy/csr-data-transfer-config-list',
        'component': () => import('@/components/content/system/strategy/csr-data-transfer-config-list.vue')
    },
    {
        'path': '/system/strategy/mes-strategy',
        'name': 'system/strategy/mes-strategy',
        'component': () => import('@/components/content/system/strategy/mes-strategy.vue')
    },
    {
        'path': '/system/strategy/qms-strategy',
        'name': 'system/strategy/qms-strategy',
        'component': () => import('@/components/content/system/strategy/qms-strategy.vue')
    },
    {
        'path': '/system/strategy/strategy-log',
        'name': 'system/strategy/strategy-log',
        'component': () => import('@/components/content/system/strategy/strategy-log.vue')
    },
    {
        'path': '/system/strategy/wms-out-house-check-rule',
        'name': 'system/strategy/wms-out-house-check-rule',
        'component': () => import('@/components/content/system/strategy/wms-out-house-check-rule.vue')
    },
    {
        'path': '/system/strategy/wms-strategy',
        'name': 'system/strategy/wms-strategy',
        'component': () => import('@/components/content/system/strategy/wms-strategy.vue')
    },
    {
        'path': '/visual/visual-category',
        'name': 'visual/visual-category',
        'component': () => import('@/components/content/visual/visual-category.vue')
    },
    {
        'path': '/visual/visual',
        'name': 'visual/visual',
        'component': () => import('@/components/content/visual/visual.vue')
    },
    {
        'path': '/wms/check/material-sn-check',
        'name': 'wms/check/material-sn-check',
        'component': () => import('@/components/content/wms/check/material-sn-check.vue')
    },
    {
        'path': '/wms/check/to-material-sn-check',
        'name': 'wms/check/to-material-sn-check',
        'component': () => import('@/components/content/wms/check/to-material-sn-check.vue')
    },
    {
        'path': '/wms/in-stock/customer/customer-in-stock-order-dispense',
        'name': 'wms/in-stock/customer/customer-in-stock-order-dispense',
        'component': () => import('@/components/content/wms/in-stock/customer/customer-in-stock-order-dispense.vue')
    },
    {
        'path': '/wms/in-stock/customer/customer-in-stock-order',
        'name': 'wms/in-stock/customer/customer-in-stock-order',
        'component': () => import('@/components/content/wms/in-stock/customer/customer-in-stock-order.vue')
    },
    {
        'path': '/wms/in-stock/in-stock-order-dispense',
        'name': 'wms/in-stock/in-stock-order-dispense',
        'component': () => import('@/components/content/wms/in-stock/in-stock-order-dispense.vue')
    },
    {
        'path': '/wms/in-stock/in-stock-order',
        'name': 'wms/in-stock/in-stock-order',
        'component': () => import('@/components/content/wms/in-stock/in-stock-order.vue')
    },
    {
        'path': '/wms/in-stock/in-stock-task-dispense',
        'name': 'wms/in-stock/in-stock-task-dispense',
        'component': () => import('@/components/content/wms/in-stock/in-stock-task-dispense.vue')
    },
    {
        'path': '/wms/in-stock/in-stock-task',
        'name': 'wms/in-stock/in-stock-task',
        'component': () => import('@/components/content/wms/in-stock/in-stock-task.vue')
    },
    {
        'path': '/wms/in-stock/other/other-in-stock-order-dispense',
        'name': 'wms/in-stock/other/other-in-stock-order-dispense',
        'component': () => import('@/components/content/wms/in-stock/other/other-in-stock-order-dispense.vue')
    },
    {
        'path': '/wms/in-stock/other/other-in-stock-order',
        'name': 'wms/in-stock/other/other-in-stock-order',
        'component': () => import('@/components/content/wms/in-stock/other/other-in-stock-order.vue')
    },
    {
        'path': '/wms/in-stock/purchase/purchase-in-stock-order-dispense',
        'name': 'wms/in-stock/purchase/purchase-in-stock-order-dispense',
        'component': () => import('@/components/content/wms/in-stock/purchase/purchase-in-stock-order-dispense.vue')
    },
    {
        'path': '/wms/in-stock/purchase/purchase-in-stock-order',
        'name': 'wms/in-stock/purchase/purchase-in-stock-order',
        'component': () => import('@/components/content/wms/in-stock/purchase/purchase-in-stock-order.vue')
    },
    {
        'path': '/wms/in-stock/work/work-in-stock-order-dispense',
        'name': 'wms/in-stock/work/work-in-stock-order-dispense',
        'component': () => import('@/components/content/wms/in-stock/work/work-in-stock-order-dispense.vue')
    },
    {
        'path': '/wms/in-stock/work/work-in-stock-order',
        'name': 'wms/in-stock/work/work-in-stock-order',
        'component': () => import('@/components/content/wms/in-stock/work/work-in-stock-order.vue')
    },
    {
        'path': '/wms/init-stock/init-stock-order-register',
        'name': 'wms/init-stock/init-stock-order-register',
        'component': () => import('@/components/content/wms/init-stock/init-stock-order-register.vue')
    },
    {
        'path': '/wms/init-stock/init-stock-order',
        'name': 'wms/init-stock/init-stock-order',
        'component': () => import('@/components/content/wms/init-stock/init-stock-order.vue')
    },
    {
        'path': '/wms/initialize-stock/init-stock-register',
        'name': 'wms/initialize-stock/init-stock-register',
        'component': () => import('@/components/content/wms/initialize-stock/init-stock-register.vue')
    },
    {
        'path': '/wms/initialize-stock/initialize-stock',
        'name': 'wms/initialize-stock/initialize-stock',
        'component': () => import('@/components/content/wms/initialize-stock/initialize-stock.vue')
    },
    {
        'path': '/wms/inventory/inventory-order-add',
        'name': 'wms/inventory/inventory-order-add',
        'component': () => import('@/components/content/wms/inventory/inventory-order-add.vue')
    },
    {
        'path': '/wms/inventory/inventory-order-dispense',
        'name': 'wms/inventory/inventory-order-dispense',
        'component': () => import('@/components/content/wms/inventory/inventory-order-dispense.vue')
    },
    {
        'path': '/wms/inventory/inventory-order',
        'name': 'wms/inventory/inventory-order',
        'component': () => import('@/components/content/wms/inventory/inventory-order.vue')
    },
    {
        'path': '/wms/inventory/inventory-report',
        'name': 'wms/inventory/inventory-report',
        'component': () => import('@/components/content/wms/inventory/inventory-report.vue')
    },
    {
        'path': '/wms/inventory/inventory-task-dispense',
        'name': 'wms/inventory/inventory-task-dispense',
        'component': () => import('@/components/content/wms/inventory/inventory-task-dispense.vue')
    },
    {
        'path': '/wms/inventory/inventory-task',
        'name': 'wms/inventory/inventory-task',
        'component': () => import('@/components/content/wms/inventory/inventory-task.vue')
    },
    {
        'path': '/wms/material-management/dull-area-config',
        'name': 'wms/material-management/dull-area-config',
        'component': () => import('@/components/content/wms/material-management/dull-area-config.vue')
    },
    {
        'path': '/wms/material-management/material-code-chang-log',
        'name': 'wms/material-management/material-code-chang-log',
        'component': () => import('@/components/content/wms/material-management/material-code-chang-log.vue')
    },
    {
        'path': '/wms/material-management/material-inventory-age',
        'name': 'wms/material-management/material-inventory-age',
        'component': () => import('@/components/content/wms/material-management/material-inventory-age.vue')
    },
    {
        'path': '/wms/material-management/material-sn-check-num',
        'name': 'wms/material-management/material-sn-check-num',
        'component': () => import('@/components/content/wms/material-management/material-sn-check-num.vue')
    },
    {
        'path': '/wms/material-management/material-sn-material-register-anlin',
        'name': 'wms/material-management/material-sn-material-register-anlin',
        'component': () => import('@/components/content/wms/material-management/material-sn-material-register-anlin.vue')
    },
    {
        'path': '/wms/material-management/material-sn-material-register-boduo',
        'name': 'wms/material-management/material-sn-material-register-boduo',
        'component': () => import('@/components/content/wms/material-management/material-sn-material-register-boduo.vue')
    },
    {
        'path': '/wms/material-management/material-sn-material-register',
        'name': 'wms/material-management/material-sn-material-register',
        'component': () => import('@/components/content/wms/material-management/material-sn-material-register.vue')
    },
    {
        'path': '/wms/material-management/material-sn-parse-register',
        'name': 'wms/material-management/material-sn-parse-register',
        'component': () => import('@/components/content/wms/material-management/material-sn-parse-register.vue')
    },
    {
        'path': '/wms/material-management/material-sn-split',
        'name': 'wms/material-management/material-sn-split',
        'component': () => import('@/components/content/wms/material-management/material-sn-split.vue')
    },
    {
        'path': '/wms/material-management/material-transaction-category',
        'name': 'wms/material-management/material-transaction-category',
        'component': () => import('@/components/content/wms/material-management/material-transaction-category.vue')
    },
    {
        'path': '/wms/material-management/material-transaction-detailed',
        'name': 'wms/material-management/material-transaction-detailed',
        'component': () => import('@/components/content/wms/material-management/material-transaction-detailed.vue')
    },
    {
        'path': '/wms/material-management/material-transaction-summary',
        'name': 'wms/material-management/material-transaction-summary',
        'component': () => import('@/components/content/wms/material-management/material-transaction-summary.vue')
    },
    {
        'path': '/wms/material-management/material-urgent',
        'name': 'wms/material-management/material-urgent',
        'component': () => import('@/components/content/wms/material-management/material-urgent.vue')
    },
    {
        'path': '/wms/material-management/msd-list',
        'name': 'wms/material-management/msd-list',
        'component': () => import('@/components/content/wms/material-management/msd-list.vue')
    },
    {
        'path': '/wms/material-management/validity-handle',
        'name': 'wms/material-management/validity-handle',
        'component': () => import('@/components/content/wms/material-management/validity-handle.vue')
    },
    {
        'path': '/wms/material-management/validity-management',
        'name': 'wms/material-management/validity-management',
        'component': () => import('@/components/content/wms/material-management/validity-management.vue')
    },
    {
        'path': '/wms/material-management/wms-material-pack-adjust',
        'name': 'wms/material-management/wms-material-pack-adjust',
        'component': () => import('@/components/content/wms/material-management/wms-material-pack-adjust.vue')
    },
    {
        'path': '/wms/material-management/wms-material-pack',
        'name': 'wms/material-management/wms-material-pack',
        'component': () => import('@/components/content/wms/material-management/wms-material-pack.vue')
    },
    {
        'path': '/wms/order/sales/sales-order-list',
        'name': 'wms/order/sales/sales-order-list',
        'component': () => import('@/components/content/wms/order/sales/sales-order-list.vue')
    },
    {
        'path': '/wms/order/sales/sales-order',
        'name': 'wms/order/sales/sales-order',
        'component': () => import('@/components/content/wms/order/sales/sales-order.vue')
    },
    {
        'path': '/wms/order/work/work-order-item',
        'name': 'wms/order/work/work-order-item',
        'component': () => import('@/components/content/wms/order/work/work-order-item.vue')
    },
    {
        'path': '/wms/order/work/work-order-list',
        'name': 'wms/order/work/work-order-list',
        'component': () => import('@/components/content/wms/order/work/work-order-list.vue')
    },
    {
        'path': '/wms/order/work/work-order-register',
        'name': 'wms/order/work/work-order-register',
        'component': () => import('@/components/content/wms/order/work/work-order-register.vue')
    },
    {
        'path': '/wms/order/work/work-order-restrict-material',
        'name': 'wms/order/work/work-order-restrict-material',
        'component': () => import('@/components/content/wms/order/work/work-order-restrict-material.vue')
    },
    {
        'path': '/wms/order/work/work-order',
        'name': 'wms/order/work/work-order',
        'component': () => import('@/components/content/wms/order/work/work-order.vue')
    },
    {
        'path': '/wms/out-stock/chip-out-order-item',
        'name': 'wms/out-stock/chip-out-order-item',
        'component': () => import('@/components/content/wms/out-stock/chip-out-order-item.vue')
    },
    {
        'path': '/wms/out-stock/chip-out-order',
        'name': 'wms/out-stock/chip-out-order',
        'component': () => import('@/components/content/wms/out-stock/chip-out-order.vue')
    },
    {
        'path': '/wms/out-stock/cost-center/cost-center-out-stock-order',
        'name': 'wms/out-stock/cost-center/cost-center-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/cost-center/cost-center-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/material-bind-cus-material-code-log',
        'name': 'wms/out-stock/material-bind-cus-material-code-log',
        'component': () => import('@/components/content/wms/out-stock/material-bind-cus-material-code-log.vue')
    },
    {
        'path': '/wms/out-stock/other/other-out-stock-order-dispense',
        'name': 'wms/out-stock/other/other-out-stock-order-dispense',
        'component': () => import('@/components/content/wms/out-stock/other/other-out-stock-order-dispense.vue')
    },
    {
        'path': '/wms/out-stock/other/other-out-stock-order',
        'name': 'wms/out-stock/other/other-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/other/other-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/other-apply/other-out-house-apply-order',
        'name': 'wms/out-stock/other-apply/other-out-house-apply-order',
        'component': () => import('@/components/content/wms/out-stock/other-apply/other-out-house-apply-order.vue')
    },
    {
        'path': '/wms/out-stock/out-stock-exec',
        'name': 'wms/out-stock/out-stock-exec',
        'component': () => import('@/components/content/wms/out-stock/out-stock-exec.vue')
    },
    {
        'path': '/wms/out-stock/out-stock-order-dispense',
        'name': 'wms/out-stock/out-stock-order-dispense',
        'component': () => import('@/components/content/wms/out-stock/out-stock-order-dispense.vue')
    },
    {
        'path': '/wms/out-stock/out-stock-order',
        'name': 'wms/out-stock/out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/out-stock-task-dispense',
        'name': 'wms/out-stock/out-stock-task-dispense',
        'component': () => import('@/components/content/wms/out-stock/out-stock-task-dispense.vue')
    },
    {
        'path': '/wms/out-stock/out-stock-task',
        'name': 'wms/out-stock/out-stock-task',
        'component': () => import('@/components/content/wms/out-stock/out-stock-task.vue')
    },
    {
        'path': '/wms/out-stock/out-stock-work-order',
        'name': 'wms/out-stock/out-stock-work-order',
        'component': () => import('@/components/content/wms/out-stock/out-stock-work-order.vue')
    },
    {
        'path': '/wms/out-stock/outsource/outsource-out-stock-order-dispense',
        'name': 'wms/out-stock/outsource/outsource-out-stock-order-dispense',
        'component': () => import('@/components/content/wms/out-stock/outsource/outsource-out-stock-order-dispense.vue')
    },
    {
        'path': '/wms/out-stock/outsource/outsource-out-stock-order',
        'name': 'wms/out-stock/outsource/outsource-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/outsource/outsource-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/parts-out-stock-order',
        'name': 'wms/out-stock/parts-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/parts-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/project/project-out-stock-order',
        'name': 'wms/out-stock/project/project-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/project/project-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/purchase-returned-out-stock-order',
        'name': 'wms/out-stock/purchase-returned-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/purchase-returned-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/sales/sales-out-stock-order-dispense',
        'name': 'wms/out-stock/sales/sales-out-stock-order-dispense',
        'component': () => import('@/components/content/wms/out-stock/sales/sales-out-stock-order-dispense.vue')
    },
    {
        'path': '/wms/out-stock/sales/sales-out-stock-order',
        'name': 'wms/out-stock/sales/sales-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/sales/sales-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/scrap-out-stock-order',
        'name': 'wms/out-stock/scrap-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/scrap-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/work/work-out-stock-order-dispense',
        'name': 'wms/out-stock/work/work-out-stock-order-dispense',
        'component': () => import('@/components/content/wms/out-stock/work/work-out-stock-order-dispense.vue')
    },
    {
        'path': '/wms/out-stock/work/work-out-stock-order',
        'name': 'wms/out-stock/work/work-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/work/work-out-stock-order.vue')
    },
    {
        'path': '/wms/out-stock/work-recovery-out-stock-order',
        'name': 'wms/out-stock/work-recovery-out-stock-order',
        'component': () => import('@/components/content/wms/out-stock/work-recovery-out-stock-order.vue')
    },
    {
        'path': '/wms/purchase/purchase-order-list',
        'name': 'wms/purchase/purchase-order-list',
        'component': () => import('@/components/content/wms/purchase/purchase-order-list.vue')
    },
    {
        'path': '/wms/purchase/purchase-order-register',
        'name': 'wms/purchase/purchase-order-register',
        'component': () => import('@/components/content/wms/purchase/purchase-order-register.vue')
    },
    {
        'path': '/wms/purchase/purchase-order',
        'name': 'wms/purchase/purchase-order',
        'component': () => import('@/components/content/wms/purchase/purchase-order.vue')
    },
    {
        'path': '/wms/push-down-order/order-push-down',
        'name': 'wms/push-down-order/order-push-down',
        'component': () => import('@/components/content/wms/push-down-order/order-push-down.vue')
    },
    {
        'path': '/wms/quarantine/quarantine-order',
        'name': 'wms/quarantine/quarantine-order',
        'component': () => import('@/components/content/wms/quarantine/quarantine-order.vue')
    },
    {
        'path': '/wms/receipt/customer-receipt/customer-receipt-order-list',
        'name': 'wms/receipt/customer-receipt/customer-receipt-order-list',
        'component': () => import('@/components/content/wms/receipt/customer-receipt/customer-receipt-order-list.vue')
    },
    {
        'path': '/wms/receipt/customer-receipt/customer-receipt-order-register',
        'name': 'wms/receipt/customer-receipt/customer-receipt-order-register',
        'component': () => import('@/components/content/wms/receipt/customer-receipt/customer-receipt-order-register.vue')
    },
    {
        'path': '/wms/receipt/customer-receipt/customer-receipt-order',
        'name': 'wms/receipt/customer-receipt/customer-receipt-order',
        'component': () => import('@/components/content/wms/receipt/customer-receipt/customer-receipt-order.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-item',
        'name': 'wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-item',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-item.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-list',
        'name': 'wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-list',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-list.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-register',
        'name': 'wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-register',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order-register.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order',
        'name': 'wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/customer-recovery-receipt-order.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/receipt-order-item',
        'name': 'wms/receipt/customer-recovery-receipt/receipt-order-item',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/receipt-order-item.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/receipt-order-list',
        'name': 'wms/receipt/customer-recovery-receipt/receipt-order-list',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/receipt-order-list.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/receipt-order-register',
        'name': 'wms/receipt/customer-recovery-receipt/receipt-order-register',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/receipt-order-register.vue')
    },
    {
        'path': '/wms/receipt/customer-recovery-receipt/receipt-order',
        'name': 'wms/receipt/customer-recovery-receipt/receipt-order',
        'component': () => import('@/components/content/wms/receipt/customer-recovery-receipt/receipt-order.vue')
    },
    {
        'path': '/wms/receipt/iqc-receipt/iqc-receipt-order-register',
        'name': 'wms/receipt/iqc-receipt/iqc-receipt-order-register',
        'component': () => import('@/components/content/wms/receipt/iqc-receipt/iqc-receipt-order-register.vue')
    },
    {
        'path': '/wms/receipt/purchase-receipt/purchase-receipt-order-list',
        'name': 'wms/receipt/purchase-receipt/purchase-receipt-order-list',
        'component': () => import('@/components/content/wms/receipt/purchase-receipt/purchase-receipt-order-list.vue')
    },
    {
        'path': '/wms/receipt/purchase-receipt/purchase-receipt-order-register',
        'name': 'wms/receipt/purchase-receipt/purchase-receipt-order-register',
        'component': () => import('@/components/content/wms/receipt/purchase-receipt/purchase-receipt-order-register.vue')
    },
    {
        'path': '/wms/receipt/purchase-receipt/purchase-receipt-order',
        'name': 'wms/receipt/purchase-receipt/purchase-receipt-order',
        'component': () => import('@/components/content/wms/receipt/purchase-receipt/purchase-receipt-order.vue')
    },
    {
        'path': '/wms/receipt/receipt-order-item',
        'name': 'wms/receipt/receipt-order-item',
        'component': () => import('@/components/content/wms/receipt/receipt-order-item.vue')
    },
    {
        'path': '/wms/receipt/receipt-order-list',
        'name': 'wms/receipt/receipt-order-list',
        'component': () => import('@/components/content/wms/receipt/receipt-order-list.vue')
    },
    {
        'path': '/wms/receipt/receipt-order-register',
        'name': 'wms/receipt/receipt-order-register',
        'component': () => import('@/components/content/wms/receipt/receipt-order-register.vue')
    },
    {
        'path': '/wms/receipt/receipt-order',
        'name': 'wms/receipt/receipt-order',
        'component': () => import('@/components/content/wms/receipt/receipt-order.vue')
    },
    {
        'path': '/wms/recovery/outsource/outsource-recovery-order-dispense',
        'name': 'wms/recovery/outsource/outsource-recovery-order-dispense',
        'component': () => import('@/components/content/wms/recovery/outsource/outsource-recovery-order-dispense.vue')
    },
    {
        'path': '/wms/recovery/outsource/outsource-recovery-order',
        'name': 'wms/recovery/outsource/outsource-recovery-order',
        'component': () => import('@/components/content/wms/recovery/outsource/outsource-recovery-order.vue')
    },
    {
        'path': '/wms/recovery/recovery-order-dispense',
        'name': 'wms/recovery/recovery-order-dispense',
        'component': () => import('@/components/content/wms/recovery/recovery-order-dispense.vue')
    },
    {
        'path': '/wms/recovery/recovery-order',
        'name': 'wms/recovery/recovery-order',
        'component': () => import('@/components/content/wms/recovery/recovery-order.vue')
    },
    {
        'path': '/wms/recovery/recovery-task-dispense',
        'name': 'wms/recovery/recovery-task-dispense',
        'component': () => import('@/components/content/wms/recovery/recovery-task-dispense.vue')
    },
    {
        'path': '/wms/recovery/recovery-task-order',
        'name': 'wms/recovery/recovery-task-order',
        'component': () => import('@/components/content/wms/recovery/recovery-task-order.vue')
    },
    {
        'path': '/wms/recovery/recovery-task',
        'name': 'wms/recovery/recovery-task',
        'component': () => import('@/components/content/wms/recovery/recovery-task.vue')
    },
    {
        'path': '/wms/recovery/work/work-recovery-order-dispense',
        'name': 'wms/recovery/work/work-recovery-order-dispense',
        'component': () => import('@/components/content/wms/recovery/work/work-recovery-order-dispense.vue')
    },
    {
        'path': '/wms/recovery/work/work-recovery-order',
        'name': 'wms/recovery/work/work-recovery-order',
        'component': () => import('@/components/content/wms/recovery/work/work-recovery-order.vue')
    },
    {
        'path': '/wms/relation/default-component',
        'name': 'wms/relation/default-component',
        'component': () => import('@/components/content/wms/relation/default-component.vue')
    },
    {
        'path': '/wms/relation/relation-query',
        'name': 'wms/relation/relation-query',
        'component': () => import('@/components/content/wms/relation/relation-query.vue')
    },
    {
        'path': '/wms/returned/returned-order-item',
        'name': 'wms/returned/returned-order-item',
        'component': () => import('@/components/content/wms/returned/returned-order-item.vue')
    },
    {
        'path': '/wms/returned/returned-order-list',
        'name': 'wms/returned/returned-order-list',
        'component': () => import('@/components/content/wms/returned/returned-order-list.vue')
    },
    {
        'path': '/wms/returned/returned-order',
        'name': 'wms/returned/returned-order',
        'component': () => import('@/components/content/wms/returned/returned-order.vue')
    },
    {
        'path': '/wms/sales/sales-delivery-notice-order',
        'name': 'wms/sales/sales-delivery-notice-order',
        'component': () => import('@/components/content/wms/sales/sales-delivery-notice-order.vue')
    },
    {
        'path': '/wms/sales/sales-delivery-task-dispense',
        'name': 'wms/sales/sales-delivery-task-dispense',
        'component': () => import('@/components/content/wms/sales/sales-delivery-task-dispense.vue')
    },
    {
        'path': '/wms/sales/sales-delivery-task',
        'name': 'wms/sales/sales-delivery-task',
        'component': () => import('@/components/content/wms/sales/sales-delivery-task.vue')
    },
    {
        'path': '/wms/sales/sales-order-list',
        'name': 'wms/sales/sales-order-list',
        'component': () => import('@/components/content/wms/sales/sales-order-list.vue')
    },
    {
        'path': '/wms/sales/sales-return-notice-order-list',
        'name': 'wms/sales/sales-return-notice-order-list',
        'component': () => import('@/components/content/wms/sales/sales-return-notice-order-list.vue')
    },
    {
        'path': '/wms/sales/sales-return-notice-order-register',
        'name': 'wms/sales/sales-return-notice-order-register',
        'component': () => import('@/components/content/wms/sales/sales-return-notice-order-register.vue')
    },
    {
        'path': '/wms/sales/sales-return-notice-order',
        'name': 'wms/sales/sales-return-notice-order',
        'component': () => import('@/components/content/wms/sales/sales-return-notice-order.vue')
    },
    {
        'path': '/wms/sales/sales-return-task-dispense',
        'name': 'wms/sales/sales-return-task-dispense',
        'component': () => import('@/components/content/wms/sales/sales-return-task-dispense.vue')
    },
    {
        'path': '/wms/sales/sales-return-task',
        'name': 'wms/sales/sales-return-task',
        'component': () => import('@/components/content/wms/sales/sales-return-task.vue')
    },
    {
        'path': '/wms/serial-manager/material-sn-list',
        'name': 'wms/serial-manager/material-sn-list',
        'component': () => import('@/components/content/wms/serial-manager/material-sn-list.vue')
    },
    {
        'path': '/wms/serial-manager/material-sn-op-log',
        'name': 'wms/serial-manager/material-sn-op-log',
        'component': () => import('@/components/content/wms/serial-manager/material-sn-op-log.vue')
    },
    {
        'path': '/wms/serial-manager/material-sn-print',
        'name': 'wms/serial-manager/material-sn-print',
        'component': () => import('@/components/content/wms/serial-manager/material-sn-print.vue')
    },
    {
        'path': '/wms/serial-manager/material-split-trace-view',
        'name': 'wms/serial-manager/material-split-trace-view',
        'component': () => import('@/components/content/wms/serial-manager/material-split-trace-view.vue')
    },
    {
        'path': '/wms/serial-manager/sap-log',
        'name': 'wms/serial-manager/sap-log',
        'component': () => import('@/components/content/wms/serial-manager/sap-log.vue')
    },
    {
        'path': '/wms/shelf/shelf-led-callback-exception',
        'name': 'wms/shelf/shelf-led-callback-exception',
        'component': () => import('@/components/content/wms/shelf/shelf-led-callback-exception.vue')
    },
    {
        'path': '/wms/shelf/shelf-led-control',
        'name': 'wms/shelf/shelf-led-control',
        'component': () => import('@/components/content/wms/shelf/shelf-led-control.vue')
    },
    {
        'path': '/wms/stock/findMaterielCellDetail',
        'name': 'wms/stock/findMaterielCellDetail',
        'component': () => import('@/components/content/wms/stock/findMaterielCellDetail.vue')
    },
    {
        'path': '/wms/stock/findMaterielDetail',
        'name': 'wms/stock/findMaterielDetail',
        'component': () => import('@/components/content/wms/stock/findMaterielDetail.vue')
    },
    {
        'path': '/wms/stock/inventoryDetail',
        'name': 'wms/stock/inventoryDetail',
        'component': () => import('@/components/content/wms/stock/inventoryDetail.vue')
    },
    {
        'path': '/wms/stock/inventorySummary',
        'name': 'wms/stock/inventorySummary',
        'component': () => import('@/components/content/wms/stock/inventorySummary.vue')
    },
    {
        'path': '/wms/stock/jit-stock',
        'name': 'wms/stock/jit-stock',
        'component': () => import('@/components/content/wms/stock/jit-stock.vue')
    },
    {
        'path': '/wms/stock/lot-adjust-order/lot-adjust-order-list',
        'name': 'wms/stock/lot-adjust-order/lot-adjust-order-list',
        'component': () => import('@/components/content/wms/stock/lot-adjust-order/lot-adjust-order-list.vue')
    },
    {
        'path': '/wms/stock/lot-adjust-order/lot-adjust-order',
        'name': 'wms/stock/lot-adjust-order/lot-adjust-order',
        'component': () => import('@/components/content/wms/stock/lot-adjust-order/lot-adjust-order.vue')
    },
    {
        'path': '/wms/stock/mantissa-materiel-in-house',
        'name': 'wms/stock/mantissa-materiel-in-house',
        'component': () => import('@/components/content/wms/stock/mantissa-materiel-in-house.vue')
    },
    {
        'path': '/wms/stock/material-adjust-order/material-adjust-order-list',
        'name': 'wms/stock/material-adjust-order/material-adjust-order-list',
        'component': () => import('@/components/content/wms/stock/material-adjust-order/material-adjust-order-list.vue')
    },
    {
        'path': '/wms/stock/material-adjust-order/material-adjust-order',
        'name': 'wms/stock/material-adjust-order/material-adjust-order',
        'component': () => import('@/components/content/wms/stock/material-adjust-order/material-adjust-order.vue')
    },
    {
        'path': '/wms/stock/stock',
        'name': 'wms/stock/stock',
        'component': () => import('@/components/content/wms/stock/stock.vue')
    },
    {
        'path': '/wms/stock-task/comp/task-overviews',
        'name': 'wms/stock-task/comp/task-overviews',
        'component': () => import('@/components/content/wms/stock-task/comp/task-overviews.vue')
    },
    {
        'path': '/wms/stock-task/comp/task-table',
        'name': 'wms/stock-task/comp/task-table',
        'component': () => import('@/components/content/wms/stock-task/comp/task-table.vue')
    },
    {
        'path': '/wms/stock-task/scheduling-task',
        'name': 'wms/stock-task/scheduling-task',
        'component': () => import('@/components/content/wms/stock-task/scheduling-task.vue')
    },
    {
        'path': '/wms/stock-task/stock-task',
        'name': 'wms/stock-task/stock-task',
        'component': () => import('@/components/content/wms/stock-task/stock-task.vue')
    },
    {
        'path': '/wms/stock-task/task-dispense',
        'name': 'wms/stock-task/task-dispense',
        'component': () => import('@/components/content/wms/stock-task/task-dispense.vue')
    },
    {
        'path': '/wms/transfer/direct/direct-transfer-order-dispense',
        'name': 'wms/transfer/direct/direct-transfer-order-dispense',
        'component': () => import('@/components/content/wms/transfer/direct/direct-transfer-order-dispense.vue')
    },
    {
        'path': '/wms/transfer/direct/direct-transfer-order',
        'name': 'wms/transfer/direct/direct-transfer-order',
        'component': () => import('@/components/content/wms/transfer/direct/direct-transfer-order.vue')
    },
    {
        'path': '/wms/transfer/step-in/step-in-transfer-order-dispense',
        'name': 'wms/transfer/step-in/step-in-transfer-order-dispense',
        'component': () => import('@/components/content/wms/transfer/step-in/step-in-transfer-order-dispense.vue')
    },
    {
        'path': '/wms/transfer/step-in/step-in-transfer-order',
        'name': 'wms/transfer/step-in/step-in-transfer-order',
        'component': () => import('@/components/content/wms/transfer/step-in/step-in-transfer-order.vue')
    },
    {
        'path': '/wms/transfer/step-out/step-out-transfer-order-dispense',
        'name': 'wms/transfer/step-out/step-out-transfer-order-dispense',
        'component': () => import('@/components/content/wms/transfer/step-out/step-out-transfer-order-dispense.vue')
    },
    {
        'path': '/wms/transfer/step-out/step-out-transfer-order',
        'name': 'wms/transfer/step-out/step-out-transfer-order',
        'component': () => import('@/components/content/wms/transfer/step-out/step-out-transfer-order.vue')
    },
    {
        'path': '/wms/transfer/transfer-order-dispense',
        'name': 'wms/transfer/transfer-order-dispense',
        'component': () => import('@/components/content/wms/transfer/transfer-order-dispense.vue')
    },
    {
        'path': '/wms/transfer/transfer-order',
        'name': 'wms/transfer/transfer-order',
        'component': () => import('@/components/content/wms/transfer/transfer-order.vue')
    },
    {
        'path': '/wms/transfer/transfer-task-dispense',
        'name': 'wms/transfer/transfer-task-dispense',
        'component': () => import('@/components/content/wms/transfer/transfer-task-dispense.vue')
    },
    {
        'path': '/wms/transfer/transfer-task',
        'name': 'wms/transfer/transfer-task',
        'component': () => import('@/components/content/wms/transfer/transfer-task.vue')
    },
    {
        'path': '/wms/turn-order/material-turn-order',
        'name': 'wms/turn-order/material-turn-order',
        'component': () => import('@/components/content/wms/turn-order/material-turn-order.vue')
    },
    {
        'path': '/wms/turn-order/turn-order',
        'name': 'wms/turn-order/turn-order',
        'component': () => import('@/components/content/wms/turn-order/turn-order.vue')
    },
    {
        'path': '/wms/turn-order/turn-task',
        'name': 'wms/turn-order/turn-task',
        'component': () => import('@/components/content/wms/turn-order/turn-task.vue')
    }
]



// WEBPACK FOOTER //
// ./src/router/compsIndexes.js